<template>
  <div>
    <v-container
      fluid
      :class="{
        'mx-12': !mobile,
        'my-4': !mobile
      }"
    >
      <v-row>
        <v-col cols="12" md="8">
          <div class="card-label d-flex flex-row mb-4">
            <v-icon>mdi-information-outline</v-icon>
            <p class="mb-0 ml-4 subtitle-2 font-weight-bold">Rent Details</p>
          </div>
          <v-card
            v-if="!detailsLoading"
            elevation="0"
            :class="{
              'card-container': true,
              'px-8': !mobile,
              'py-6': !mobile,
              'px-4': mobile,
              'py-2': mobile,
              'd-flex': mobile,
              'flex-row': mobile
            }"
          >
            <v-row :class="{ 'pl-2': mobile }">
              <v-col
                cols="auto"
                sm="2"
                md="3"
                :class="{
                  'py-0': true,
                  'px-0': mobile,
                  'py-1': mobile
                }"
              >
                <div class="d-flex flex-row">
                  <p class="caption">Due Date</p>

                  <v-tooltip
                    v-if="unpaidPreviousRentalPaymentRequests.length"
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon class="ml-1" color="warning" small v-on="on"
                        >mdi-alert-circle</v-icon
                      >
                    </template>
                    <p class="caption white--text">
                      There are past unpaid rental payment requests
                      <br />
                      {{ unpaidPreviousRentalPaymentRequestsRefNoList }}
                    </p>
                  </v-tooltip>
                  <v-icon
                    v-if="access.update"
                    small
                    class="ml-1"
                    color="primary"
                    @click="setShowUpdateDueDate"
                    >mdi-pencil</v-icon
                  >
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="3"
                :class="{
                  'py-0': true,
                  'px-0': mobile,
                  'py-1': mobile
                }"
              >
                <div class="d-flex flex-row">
                  <p class="caption">Rent Fee</p>
                  <v-icon
                    v-if="access.update"
                    small
                    class="ml-1"
                    color="primary"
                    @click="setShowUpdateRentFee"
                    >mdi-pencil</v-icon
                  >
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                md="6"
                :class="{
                  'py-0': true,
                  'px-0': mobile,
                  'py-1': mobile
                }"
              >
                <div class="d-flex flex-row">
                  <p class="caption">Contract Period</p>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="4"
                md="3"
                :align="alignRentDetails"
                :class="{
                  'py-0': true,
                  'px-2': mobile,
                  'py-1': mobile
                }"
              >
                <div v-if="!showUpdateDueDate">
                  <p :class="dueDateColor">
                    {{ lastSavedDueDate }}
                  </p>
                  <p v-if="bedDetails.preTerminated" class="caption grey--text">
                    Pre-terminated
                  </p>
                  <p v-else-if="paymentCompleted" class="caption grey--text">
                    Payment Completed
                  </p>
                </div>
                <div v-else>
                  <!-- <v-text-field
                    outlined
                    dense
                    hint="Update Due Date"
                    persistent-hint
                    v-model="dueDate"
                  ></v-text-field> -->
                  <v-menu
                    v-model="dueDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formatDate(dueDate)"
                        v-bind="attrs"
                        hint="Update Due Date"
                        persistent-hint
                        outlined
                        dense
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dueDate"
                      no-title
                      scrollable
                      @input="dueDateMenu = false"
                    >
                    </v-date-picker>
                  </v-menu>
                  <div class="d-flex flex-row">
                    <v-spacer></v-spacer>
                    <v-btn
                      depressed
                      class="mt-0 mr-2 mb-2"
                      x-small
                      @click="setShowUpdateDueDate"
                      >Cancel</v-btn
                    >
                    <v-btn
                      depressed
                      class="mt-0 mb-2"
                      color="primary"
                      x-small
                      @click="updateDueDate"
                      >Save</v-btn
                    >
                  </div>
                </div>
              </v-col>
              <v-col
                cols="12"
                sm="8"
                md="9"
                :class="{
                  'py-0': true
                }"
              >
                <v-row
                  v-for="(contractPeriod, index) in contractPeriods"
                  :key="index"
                >
                  <v-col
                    v-if="contractPeriod.active"
                    cols="12"
                    sm="4"
                    md="4"
                    :align="alignRentDetails"
                    :class="{
                      'py-0': true,
                      'px-2': mobile,
                      'py-1': mobile
                    }"
                  >
                    <p
                      v-if="!showUpdateRentFee"
                      class="body-2 font-weight-bold"
                    >
                      {{ formatCurrency(lastSavedRentFee) }}
                    </p>
                    <div v-else>
                      <v-currency-field
                        v-model="rentFee"
                        outlined
                        dense
                        hint="Update Rent Fee"
                        persistent-hint
                      ></v-currency-field>
                      <div class="d-flex flex-row">
                        <v-spacer></v-spacer>
                        <v-btn
                          depressed
                          class="mt-0 mr-2 mb-2"
                          x-small
                          @click="setShowUpdateRentFee"
                          >Cancel</v-btn
                        >
                        <v-btn
                          depressed
                          class="mt-0 mb-2"
                          color="primary"
                          x-small
                          @click="updateRentFee"
                          >Save</v-btn
                        >
                      </div>
                    </div>
                  </v-col>
                  <v-col
                    v-if="contractPeriod.active"
                    cols="12"
                    sm="4"
                    md="8"
                    :align="alignRentDetails"
                    :class="{
                      'py-0': true,
                      'px-2': mobile,
                      'py-1': mobile
                    }"
                  >
                    <div
                      v-if="bedDetails.status === 'expired'"
                      class="d-flex flex-row"
                    >
                      <p class="body-2 font-weight-bold red--text">
                        {{
                          formatFullDate(bedDetails.moveInDate) +
                          ' - ' +
                          formatFullDate(bedDetails.moveOutDate)
                        }}
                      </p>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon color="red" class="ml-1" small v-on="on"
                            >mdi-alert-circle</v-icon
                          >
                        </template>
                        <p class="white--text">
                          The contract period has expired.
                        </p>
                      </v-tooltip>
                    </div>
                    <div v-else>
                      <p v-if="!mobile" class="body-2 font-weight-bold">
                        {{
                          formatFullDate(bedDetails.moveInDate) +
                          ' - ' +
                          formatFullDate(bedDetails.moveOutDate)
                        }}
                      </p>
                      <p v-else class="caption font-weight-bold">
                        {{ formatDateMobile(new Date(bedDetails.moveInDate)) }}
                        -
                        {{ formatDateMobile(new Date(bedDetails.moveOutDate)) }}
                      </p>
                    </div>
                  </v-col>
                  <v-col
                    v-if="!contractPeriod.active"
                    cols="12"
                    sm="4"
                    md="4"
                    class="py-0"
                  >
                    <p class="body-2">
                      {{ formatCurrency(contractPeriod.rentFee) }}
                    </p>
                  </v-col>
                  <v-col
                    v-if="!contractPeriod.active"
                    cols="12"
                    sm="4"
                    md="8"
                    class="py-0"
                  >
                    <p class="body-2">
                      {{
                        formatFullDate(contractPeriod.moveInDate) +
                        ' - ' +
                        formatFullDate(contractPeriod.moveOutDate)
                      }}
                    </p>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
          <v-skeleton-loader
            v-else
            ref="skeleton"
            type="article"
            loading
            class="mx-auto"
            max-height="150"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="4" :class="{ 'my-2': mobile }">
          <div class="card-label d-flex flex-row mb-4 justify-space-between">
            <div class="d-flex flex-row">
              <v-icon>mdi-account-cash-outline</v-icon>
              <p class="mb-0 ml-4 subtitle-2 font-weight-bold">Account</p>
            </div>
            <div class="d-flex flex-row">
              <v-btn
                v-if="showAmountDue"
                text
                x-small
                color="primary"
                @click="showBalance(false)"
                >Show breakdown</v-btn
              >
              <v-btn
                v-else
                text
                x-small
                color="primary"
                @click="showBalance(true)"
                >Show total</v-btn
              >
            </div>
          </div>
          <v-card
            v-if="!detailsLoading"
            :class="{
              'card-container': true,
              'pa-4': !mobile,
              'pa-0': mobile
            }"
            elevation="0"
          >
            <v-row v-if="showAmountDue">
              <v-col cols="12" md="12">
                <p class="caption text-center">Amount Due</p>
                <p
                  v-if="!amountDue || amountDue < 0"
                  class="h6 font-weight-bold text-center"
                >
                  {{ formatCurrency(amountDue) || 0 }}
                </p>
                <p v-else class="h6 font-weight-bold text-center red--text">
                  {{ formatCurrency(amountDue) }}
                </p>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col cols="12" md="6">
                <p class="caption text-center">Credits</p>
                <p
                  v-if="!bedDetails.balance || bedDetails.balance >= 0"
                  class="h6 font-weight-bold text-center"
                >
                  {{ formatCurrency(bedDetails.balance) || 0 }}
                </p>
                <p v-else class="h6 font-weight-bold text-center red--text">
                  {{ formatCurrency(bedDetails.balance) }}
                </p>
              </v-col>
              <v-col cols="12" md="6">
                <p class="caption text-center">Pending Payments</p>
                <p
                  v-if="!pendingBalance || pendingBalance < 0"
                  class="h6 font-weight-bold text-center"
                >
                  {{ formatCurrency(pendingBalance || 0) }}
                </p>
                <p v-else class="h6 font-weight-bold text-center red--text">
                  {{ formatCurrency(pendingBalance) }}
                </p>
              </v-col>
            </v-row>
          </v-card>
          <v-skeleton-loader
            v-else
            ref="skeleton"
            type="article"
            loading
            class="mx-auto"
            max-height="150"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row :class="{ 'py-2': mobile }">
        <v-col
          cols="12"
          sm="12"
          md="8"
          :class="{ 'pa-0': mobile, 'my-2': mobile }"
        >
          <div
            :class="{
              'card-label': true,
              'd-flex': true,
              'flex-row': true,
              'mb-4': !mobile,
              'mx-2': mobile,
              'my-2': mobile
            }"
          >
            <v-icon>mdi-account-details-outline</v-icon>
            <p class="mb-0 ml-4 subtitle-2 font-weight-bold">
              General Information
            </p>
          </div>
          <v-card
            v-if="!detailsLoading"
            elevation="0"
            :class="{
              'card-container': true,
              'px-8': !mobile,
              'py-6': !mobile,
              'mx-2': mobile,
              'px-2': mobile,
              'py-2': mobile,
              'flex-grow-1': !mobile
            }"
          >
            <div v-if="!mobile">
              <v-row>
                <v-col cols="12" md="6" class="py-0">
                  <p class="caption">Tenant</p>
                </v-col>
                <v-col cols="12" md="6" class="py-0">
                  <div class="d-flex flex-row">
                    <p class="caption">Next rental billing period</p>
                    <v-icon
                      v-if="access.update"
                      small
                      class="ml-1"
                      color="primary"
                      @click="setShowUpdateRentalPeriod"
                      >mdi-pencil</v-icon
                    >
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="4" md="6" class="py-0">
                  <div v-if="!showUpdateAlias" class="d-flex flex-row">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <a
                          class="d-flex flex-row"
                          @click="redirectUser"
                          v-on="on"
                        >
                          <v-avatar
                            size="24"
                            left
                            color="grey"
                            class="profile-picture mr-2"
                          >
                            <img
                              v-if="
                                bedDetails.tenant_details &&
                                bedDetails.tenant_details.profilePicture
                              "
                              class="profile-picture-img"
                              :src="getProfilePicture"
                            />
                            <v-icon v-else small dark>mdi-account</v-icon>
                          </v-avatar>
                          <p
                            class="body-2 font-weight-bold"
                            style="text-decoration: underline; color: purple"
                          >
                            {{ getTenantName }}
                          </p>
                        </a>
                      </template>
                      <p class="caption" style="color: white">
                        Email:
                        {{
                          (bedDetails.tenant_details &&
                            bedDetails.tenant_details.email1) ||
                          'N/A'
                        }}<br />
                        Username:
                        {{
                          bedDetails.tenant_details &&
                          bedDetails.tenant_details.username
                        }}
                      </p>
                    </v-tooltip>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          x-small
                          class="pl-1"
                          style="cursor: pointer"
                          color="primary"
                          @click="setShowUpdateAlias"
                          v-on="on"
                        >
                          mdi-pencil
                        </v-icon>
                      </template>
                      <p class="caption white--text">Update tenant alias</p>
                    </v-tooltip>
                  </div>
                  <div v-else>
                    <v-text-field
                      v-model="alias"
                      class="pl-8"
                      outlined
                      dense
                      hint="Update Alias"
                      persistent-hint
                    ></v-text-field>
                    <div class="d-flex flex-row">
                      <v-spacer></v-spacer>
                      <v-btn
                        depressed
                        class="mt-0 mr-2 mb-2"
                        x-small
                        @click="setShowUpdateAlias"
                        >Cancel</v-btn
                      >
                      <v-btn
                        depressed
                        class="mt-0 mb-2"
                        color="primary"
                        x-small
                        @click="updateAlias"
                        >Save</v-btn
                      >
                    </div>
                  </div>
                  <div>
                    <div v-if="!showUpdateTenantContact">
                      <div
                        v-if="
                          bedDetails.tenantContact || lastSavedTenantContact
                        "
                        class="d-flex flex-row"
                      >
                        <p class="caption pl-8">
                          {{ lastSavedTenantContact }}
                        </p>
                        <v-icon
                          x-small
                          class="pl-1"
                          style="cursor: pointer"
                          color="primary"
                          @click="setShowUpdateTenantContact"
                        >
                          mdi-pencil
                        </v-icon>
                      </div>
                      <div
                        v-else-if="
                          bedDetails.tenant_details &&
                          bedDetails.tenant_details.contactNumber1
                        "
                        class="d-flex flex-row"
                      >
                        <v-tooltip right>
                          <template v-slot:activator="{ on }">
                            <p class="caption pl-8 red--text" v-on="on">
                              {{ bedDetails.tenant_details.contactNumber1 }}
                            </p>
                          </template>
                          <p class="caption white--text">
                            Contact number acquired from tenant's account
                          </p>
                        </v-tooltip>
                        <v-icon
                          x-small
                          class="pl-1"
                          style="cursor: pointer"
                          color="primary"
                          @click="setShowUpdateTenantContact"
                        >
                          mdi-pencil
                        </v-icon>
                      </div>
                      <div v-else>
                        <a
                          class="caption d-flex flex-row pl-8"
                          @click="setShowUpdateTenantContact"
                        >
                          Add Contact Number
                        </a>
                      </div>
                    </div>
                    <div v-else>
                      <v-form v-model="isNumberValid">
                        <v-text-field
                          v-model="tenantContact"
                          outlined
                          dense
                          hint="Update Tenant Contact"
                          persistent-hint
                          class="pl-8"
                          :rules="phMobileRules"
                        ></v-text-field>
                      </v-form>
                      <div class="d-flex flex-row">
                        <v-spacer></v-spacer>
                        <v-btn
                          depressed
                          class="mt-0 mr-2 mb-2"
                          x-small
                          @click="setShowUpdateTenantContact"
                          >Cancel</v-btn
                        >
                        <v-btn
                          depressed
                          class="mt-0 mb-2"
                          color="primary"
                          x-small
                          :disabled="!isNumberValid"
                          @click="updateTenantContact"
                          >Save</v-btn
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      bedDetails.tenant_details &&
                      bedDetails.tenant_details.activationCode
                    "
                  >
                    <a
                      class="caption pl-8"
                      @click="
                        resendActivation(bedDetails.tenant_details.userId)
                      "
                      >{{ 'Resend Activation Email' }}</a
                    >
                  </div>
                </v-col>
                <v-col cols="12" sm="4" md="6" class="py-0">
                  <div v-if="showUpdateRentalPeriod">
                    <div class="d-flex flex-row">
                      <v-menu
                        v-model="updateNextRentalStartDateMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="updateNextRentalStartDate"
                            prepend-inner-icon="mdi-calendar-month"
                            v-bind="attrs"
                            persistent-hint
                            hint="Start of next billing period"
                            readonly
                            outlined
                            dense
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="updateNextRentalStartDate"
                          no-title
                          scrollable
                          @input="updateNextRentalStartDateMenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                      <p class="caption px-1 pt-2">-</p>
                      <v-text-field
                        v-model="updateNextRentalEndDate"
                        prepend-inner-icon="mdi-calendar-month"
                        disabled
                        readonly
                        outlined
                        persistent-hint
                        hint="End of next billing period"
                        dense
                      ></v-text-field>
                    </div>
                    <div class="d-flex flex-row">
                      <v-spacer></v-spacer>
                      <v-btn
                        depressed
                        class="mt-2 mr-2"
                        x-small
                        @click="setHideUpdateRentalPeriod"
                        >Cancel</v-btn
                      >
                      <v-btn
                        depressed
                        class="mt-2"
                        color="primary"
                        x-small
                        :disabled="!access.update"
                        @click="saveRentalPeriod"
                        >Save</v-btn
                      >
                    </div>
                  </div>
                  <p
                    v-else-if="bedDetails.preTerminated"
                    class="body-2 grey--text"
                  >
                    Pre-terminated
                  </p>
                  <p v-else-if="paymentCompleted" class="body-2 grey--text">
                    Payment Completed
                  </p>
                  <p v-else class="body-2 font-weight-bold">
                    {{
                      formatFullDate(nextRentalStartDate) +
                      ' - ' +
                      formatFullDate(nextRentalEndDate)
                    }}
                  </p>
                </v-col>
              </v-row>
            </div>
            <div v-else>
              <!--mobile view code, only part that needed to be restructured so can't just use dynamic classes like everything else-->
              <v-row class="ma-0 pt-2">
                <v-col class="pa-0 px-2">
                  <v-row class="ma-0" align="center">
                    <v-row class="ma-0">
                      <div
                        v-if="!showUpdateAlias"
                        class="d-flex flex-column align-center"
                      >
                        <div class="d-flex flex-row">
                          <v-tooltip right>
                            <template v-slot:activator="{ on }">
                              <a
                                class="d-flex flex-row"
                                @click="redirectUser"
                                v-on="on"
                              >
                                <span
                                  class="body-1 font-weight-bold"
                                  style="
                                    text-decoration: underline;
                                    color: purple;
                                  "
                                  >{{ getTenantName }}</span
                                >
                              </a>
                            </template>
                            <p class="caption" style="color: white">
                              Email:
                              {{
                                (bedDetails.tenant_details &&
                                  bedDetails.tenant_details.email1) ||
                                'N/A'
                              }}<br />
                              Username:
                              {{
                                bedDetails.tenant_details &&
                                bedDetails.tenant_details.username
                              }}
                            </p>
                          </v-tooltip>
                        </div>
                      </div>
                      <div v-else>
                        <v-text-field
                          v-model="alias"
                          outlined
                          dense
                          hint="Update Alias"
                          persistent-hint
                        ></v-text-field>
                        <div class="d-flex flex-row">
                          <v-btn
                            depressed
                            class="mt-0 mr-2 mb-2"
                            x-small
                            @click="setShowUpdateAlias"
                            >Cancel</v-btn
                          >
                          <v-btn
                            depressed
                            class="mt-0 mb-2"
                            color="primary"
                            x-small
                            @click="updateAlias"
                            >Save</v-btn
                          >
                        </div>
                      </div>
                      <v-spacer></v-spacer>
                      <!-- <div v-if="!showUpdateTenantContact">
                        <div v-if="bedDetails.tenantContact || lastSavedTenantContact" class="d-flex flex-row">
                          <p class="caption">{{lastSavedTenantContact}}</p>
                        </div>
                        <div v-else-if="bedDetails.tenant_details && bedDetails.tenant_details.contactNumber1" class="d-flex flex-row">
                          <v-tooltip right>
                            <template v-slot:activator="{on}">
                              <p class="caption pl-8 red--text" v-on="on">{{bedDetails.tenant_details.contactNumber1}}</p>
                            </template>
                            <p class="caption white--text">Contact number acquired from tenant's account</p>
                          </v-tooltip>
                        </div>
                        <div v-else>
                          <a class="caption d-flex flex-row" @click="setShowUpdateTenantContact">
                            Add Contact Number
                          </a>
                        </div>
                      </div>
                      <div v-else>
                        <v-form v-model ="isNumberValid">
                          <v-text-field
                            outlined
                            dense
                            hint="Update Tenant Contact"
                            persistent-hint
                            v-model="tenantContact"
                            :rules="phMobileRules"
                          ></v-text-field>
                        </v-form>
                        <div class="d-flex flex-row">
                          <v-btn depressed class="mt-0 mr-2 mb-2" x-small @click="setShowUpdateTenantContact">Cancel</v-btn>
                          <v-btn depressed class="mt-0 mb-2" color="primary" x-small @click="updateTenantContact" :disabled="!isNumberValid">Save</v-btn>
                        </div>
                      </div> -->
                      <div class="d-flex flex-row align-center">
                        <span class="body-2 font-weight-bold">{{
                          bedDetails.bedName
                        }}</span>
                      </div>
                    </v-row>
                    <!-- <v-row class="ma-0">
                      <span class="body-2 font-weight-bold">{{bedDetails.bedName}}</span>
                      <v-spacer></v-spacer>

                      <a
                        v-if="bedDetails.tenant_details && bedDetails.tenant_details.activationCode"
                        class="caption"
                        @click="resendActivation(bedDetails.tenant_details.userId)"
                      >
                        {{'Resend Activation Email'}}
                      </a>
                    </v-row> -->
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0 mt-1 mx-2">
                  <div class="d-flex flex-column">
                    <p class="caption">Billing period</p>
                    <v-spacer></v-spacer>
                    <div
                      v-if="!showUpdateRentalPeriod"
                      class="d-flex flex-column"
                    >
                      <p class="caption font-weight-bold mb-1">
                        {{
                          formatDateMobile(nextRentalStartDate) +
                          ' - ' +
                          formatDateMobile(nextRentalEndDate)
                        }}
                      </p>
                      <v-divider class=""></v-divider>
                    </div>

                    <div v-else>
                      <div class="d-flex flex-row">
                        <v-menu
                          v-model="updateNextRentalStartDateMenu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="updateNextRentalStartDate"
                              prepend-inner-icon="mdi-calendar-month"
                              v-bind="attrs"
                              persistent-hint
                              hint="Start of next billing period"
                              readonly
                              outlined
                              dense
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="updateNextRentalStartDate"
                            no-title
                            scrollable
                            @input="updateNextRentalStartDateMenu = false"
                          >
                          </v-date-picker>
                        </v-menu>
                        <p class="caption px-1 pt-2">-</p>
                        <v-text-field
                          v-model="updateNextRentalEndDate"
                          prepend-inner-icon="mdi-calendar-month"
                          disabled
                          readonly
                          outlined
                          persistent-hint
                          hint="End of next billing period"
                          dense
                        ></v-text-field>
                      </div>
                      <div class="d-flex flex-row">
                        <v-btn
                          depressed
                          class="mt-2 mr-2"
                          x-small
                          @click="setHideUpdateRentalPeriod"
                          >Cancel</v-btn
                        >
                        <v-btn
                          depressed
                          class="mt-2"
                          color="primary"
                          x-small
                          :disabled="!access.update"
                          @click="saveRentalPeriod"
                          >Save</v-btn
                        >
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>
            <div
              :class="{
                'd-flex': mobile,
                'flex-row': mobile
              }"
            >
              <v-row :class="{ 'mt-6': !mobile }">
                <v-col
                  v-if="!mobile"
                  cols="12"
                  sm="4"
                  md="6"
                  :class="{
                    'py-0': true,
                    'my-1': mobile,
                    'mx-2': mobile
                  }"
                >
                  <p class="caption">Unit Name</p>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="3"
                  :class="{
                    'py-0': true,
                    'my-1': mobile,
                    'mx-2': mobile
                  }"
                >
                  <p class="caption">Area</p>
                </v-col>
                <v-col
                  v-if="!mobile"
                  cols="12"
                  sm="4"
                  md="3"
                  :class="{
                    'py-0': true,
                    'my-1': mobile,
                    'mx-2': mobile
                  }"
                >
                  <div class="d-flex flex-row">
                    <p class="caption">Notifications</p>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  v-if="!mobile"
                  cols="12"
                  sm="4"
                  md="6"
                  :class="{
                    'py-0': true,
                    'my-1': mobile,
                    'px-2': mobile
                  }"
                >
                  <p class="body-2 font-weight-bold">
                    {{ bedDetails.bedName }}
                  </p>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="3"
                  :class="{
                    'py-0': true,
                    'my-1': mobile
                  }"
                >
                  <v-row v-if="mobile" class="ma-0 px-2" justify="end">
                    <div v-if="areaBox">
                      <v-text-field
                        v-model="area"
                        auto-grow
                        rows="1"
                        placeholder="Ex. 34 sq.m"
                        hide-details
                        outlined
                        dense
                      ></v-text-field>
                      <div class="d-flex flex-row">
                        <v-spacer></v-spacer>
                        <v-btn
                          depressed
                          class="mt-2 mr-2"
                          x-small
                          @click="hideAreaBox"
                          >Cancel</v-btn
                        >
                        <v-btn
                          depressed
                          class="mt-2"
                          color="primary"
                          x-small
                          :disabled="!access.update"
                          @click="saveArea"
                          >Save</v-btn
                        >
                      </div>
                    </div>
                    <p
                      v-else-if="lastSavedArea && !areaBox"
                      style="white-space: pre-line"
                      :class="{
                        caption: mobile,
                        'body-2': !mobile,
                        'font-weight-bold': true
                      }"
                      @click="showAreaBox"
                    >
                      {{ lastSavedArea }}
                    </p>
                    <p
                      v-else-if="!lastSavedArea && !areaBox"
                      class="body-1 grey--text"
                      @click="showAreaBox"
                    >
                      Enter area
                    </p>
                  </v-row>
                  <div v-else>
                    <div v-if="areaBox">
                      <v-text-field
                        v-model="area"
                        auto-grow
                        rows="1"
                        placeholder="Ex. 34 sq.m"
                        hide-details
                        outlined
                        dense
                      ></v-text-field>
                      <div class="d-flex flex-row">
                        <v-spacer></v-spacer>
                        <v-btn
                          depressed
                          class="mt-2 mr-2"
                          x-small
                          @click="hideAreaBox"
                          >Cancel</v-btn
                        >
                        <v-btn
                          depressed
                          class="mt-2"
                          color="primary"
                          x-small
                          :disabled="!access.update"
                          @click="saveArea"
                          >Save</v-btn
                        >
                      </div>
                    </div>
                    <p
                      v-else-if="lastSavedArea && !areaBox"
                      style="white-space: pre-line"
                      class="body-2 font-weight-bold"
                      @click="showAreaBox"
                    >
                      {{ lastSavedArea }}
                    </p>
                    <p
                      v-else-if="!lastSavedArea && !areaBox"
                      class="body-1 grey--text"
                      @click="showAreaBox"
                    >
                      Enter area
                    </p>
                  </div>
                </v-col>
                <v-col
                  v-if="!mobile"
                  cols="12"
                  sm="4"
                  md="3"
                  :class="{
                    'py-0': true,
                    'my-1': mobile,
                    'px-2': mobile
                  }"
                >
                  <v-switch
                    v-model="sendNotification"
                    class="mt-0"
                    :label="sendNotification ? 'Enabled' : 'Disabled'"
                    hide-details
                    inset
                    dense
                    readonly
                    @click.stop="setSendNotification"
                  ></v-switch>
                </v-col>
              </v-row>
            </div>
            <div
              :class="{
                'd-flex': mobile,
                'flex-row': mobile
              }"
            >
              <v-row :class="{ 'mt-6': !mobile }">
                <v-col
                  cols="12"
                  sm="4"
                  md="6"
                  :class="{
                    'py-0': true,
                    'my-1': mobile,
                    'ml-2': mobile
                  }"
                >
                  <div class="d-flex flex-row">
                    <p class="caption">Linked Units</p>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          x-small
                          class="pl-1"
                          v-on="on"
                          @click="redirectLinkUnitsDocumentation"
                          >mdi-help-circle</v-icon
                        >
                      </template>
                      <p class="white--text">Learn more</p>
                    </v-tooltip>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="6"
                  :class="{
                    'py-0': true,
                    'my-1': mobile,
                    'ml-2': mobile
                  }"
                >
                  <p class="caption">Notes</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  sm="4"
                  md="6"
                  :class="{
                    'py-0': true,
                    'my-1': mobile
                  }"
                >
                  <v-row v-if="mobile" class="ma-0 px-2" justify="end">
                    <v-chip-group
                      v-if="
                        bedDetails.childUnits_details &&
                        bedDetails.childUnits_details.length
                      "
                      column
                    >
                      <v-chip
                        v-for="(
                          linkedUnit, index
                        ) in bedDetails.childUnits_details"
                        :key="index"
                        small
                        >{{ linkedUnit.bedName }}</v-chip
                      >
                    </v-chip-group>
                    <p
                      v-else
                      :class="{
                        caption: mobile,
                        'body-1': !mobile,
                        'grey--text': true
                      }"
                    >
                      No linked units
                    </p>
                  </v-row>
                  <div v-else>
                    <v-chip-group
                      v-if="
                        bedDetails.childUnits_details &&
                        bedDetails.childUnits_details.length
                      "
                      column
                    >
                      <v-chip
                        v-for="(
                          linkedUnit, index
                        ) in bedDetails.childUnits_details"
                        :key="index"
                        small
                        >{{ linkedUnit.bedName }}</v-chip
                      >
                    </v-chip-group>
                    <p
                      v-else
                      :class="{
                        caption: mobile,
                        'body-1': !mobile,
                        'grey--text': true
                      }"
                    >
                      No linked units
                    </p>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  md="6"
                  :class="{
                    'py-0': true,
                    'my-1': mobile
                  }"
                >
                  <v-row v-if="mobile" class="ma-0 px-2" justify="end">
                    <div v-if="notesBox">
                      <v-textarea
                        v-model="notes"
                        auto-grow
                        rows="3"
                        placeholder="Enter text here"
                        hide-details
                        dense
                        outlined
                      ></v-textarea>
                      <div class="d-flex flex-row">
                        <v-spacer></v-spacer>
                        <v-btn
                          depressed
                          class="mt-2 mr-2"
                          x-small
                          @click="hideNotesBox"
                          >Cancel</v-btn
                        >
                        <v-btn
                          depressed
                          class="mt-2"
                          color="primary"
                          x-small
                          :disabled="!access.update"
                          @click="saveNotes"
                          >Save</v-btn
                        >
                      </div>
                    </div>
                    <p
                      v-else-if="lastSavedNotes && !notesBox"
                      style="white-space: pre-line"
                      :class="{
                        caption: mobile,
                        'body-2': !mobile
                      }"
                      @click="showNotesBox"
                    >
                      {{ lastSavedNotes }}
                    </p>
                    <p
                      v-else-if="!lastSavedNotes && !notesBox"
                      style="white-space: pre-line"
                      :class="{
                        caption: mobile,
                        'body-1': !mobile,
                        'grey--text': true
                      }"
                      @click="showNotesBox"
                    >
                      Click here to enter notes
                    </p>
                  </v-row>
                  <div v-else>
                    <div v-if="notesBox">
                      <v-textarea
                        v-model="notes"
                        auto-grow
                        rows="3"
                        placeholder="Enter text here"
                        hide-details
                        dense
                        outlined
                      ></v-textarea>
                      <div class="d-flex flex-row">
                        <v-spacer></v-spacer>
                        <v-btn
                          depressed
                          class="mt-2 mr-2"
                          x-small
                          @click="hideNotesBox"
                          >Cancel</v-btn
                        >
                        <v-btn
                          depressed
                          class="mt-2"
                          color="primary"
                          x-small
                          :disabled="!access.update"
                          @click="saveNotes"
                          >Save</v-btn
                        >
                      </div>
                    </div>
                    <p
                      v-else-if="lastSavedNotes && !notesBox"
                      style="white-space: pre-line"
                      :class="{
                        caption: mobile,
                        'body-2': !mobile
                      }"
                      @click="showNotesBox"
                    >
                      {{ lastSavedNotes }}
                    </p>
                    <p
                      v-else-if="!lastSavedNotes && !notesBox"
                      style="white-space: pre-line"
                      :class="{
                        caption: mobile,
                        'body-1': !mobile,
                        'grey--text': true
                      }"
                      @click="showNotesBox"
                    >
                      Click here to enter notes
                    </p>
                  </div>
                </v-col>
              </v-row>
              <v-row :class="{ 'mt-6': !mobile }">
                <v-col
                  cols="12"
                  sm="12"
                  md="12"
                  :class="{
                    'py-0': true,
                    'my-1': mobile,
                    'ml-2': mobile
                  }"
                >
                  <div class="d-flex flex-row">
                    <p class="caption">Unit Tags</p>
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-icon x-small class="pl-1" v-on="on"
                          >mdi-help-circle</v-icon
                        >
                      </template>
                      <p class="white--text">
                        These tags are associated with the unit, and remains
                        even after tenant is evicted
                      </p>
                    </v-tooltip>
                    <v-icon
                      x-small
                      class="pl-1"
                      style="cursor: pointer"
                      color="primary"
                      @click="editUnitTags"
                    >
                      mdi-pencil
                    </v-icon>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  :class="{
                    'py-0': true,
                    'my-1': mobile
                  }"
                >
                  <v-chip-group v-if="bedDetails.tags" column>
                    <v-chip
                      v-for="(tag, index) in bedDetails.tags"
                      :key="'tag_' + index"
                      small
                      >{{ tag.text }}</v-chip
                    >
                  </v-chip-group>
                </v-col>
              </v-row>
            </div>
          </v-card>
          <v-skeleton-loader
            v-else
            ref="skeleton"
            type="card"
            loading
            class="mx-auto"
          ></v-skeleton-loader>
        </v-col>
        <v-col cols="12" sm="12" md="4" :class="{ 'my-2': mobile }">
          <div class="card-label d-flex flex-row mb-4">
            <v-icon>mdi-chart-line</v-icon>
            <p class="mb-0 ml-4 subtitle-2 font-weight-bold">On Time Data</p>
          </div>
          <v-card
            v-if="!loading"
            id="chart-card"
            class="card-container pa-4"
            elevation="0"
          >
            <OnTimeRate
              ref="onTimeChart"
              :chart-data="onTimeData"
              :styles="{ height: '250px', position: 'relative' }"
              :loaded="loaded"
            ></OnTimeRate>
          </v-card>
          <v-skeleton-loader
            v-else
            ref="skeleton"
            type="card"
            loading
            class="mx-auto"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <div
            :class="{
              'card-label': true,
              'd-flex': true,
              'flex-row': !mobile,
              'flex-column': mobile,
              'mb-4': true,
              'justify-space-between': true
            }"
          >
            <div class="d-flex flex-row">
              <v-icon>mdi-cash-multiple</v-icon>
              <p class="mb-0 ml-4 subtitle-2 font-weight-bold">Transactions</p>
            </div>
            <div
              :class="{
                'd-flex': true,
                'flex-row': true,
                'offset-1': mobile
              }"
            >
              <v-btn
                depressed
                rounded
                small
                color="primary"
                :disabled="!paymentAccess.report"
                @click="openGenerateReportDialog"
              >
                <v-icon small class="pr-1">mdi-file-table</v-icon>
                Generate Report
              </v-btn>
              <v-btn
                v-if="showPaymentsCard"
                text
                small
                class="ml-2"
                color="primary"
                @click="togglePaymentsCard"
                ><v-icon small class="pr-1">mdi-eye-off</v-icon>Hide</v-btn
              >
              <v-btn
                v-else
                text
                small
                class="ml-2"
                color="primary"
                @click="togglePaymentsCard"
                ><v-icon small class="pr-1">mdi-eye</v-icon>Show</v-btn
              >
            </div>
          </div>
          <v-card
            v-if="!loading"
            v-show="showPaymentsCard"
            elevation="0"
            :class="{
              'card-container': true,
              'px-8': !mobile,
              'py-4': !mobile,
              'px-4': mobile
            }"
          >
            <div v-if="paymentAccess.read">
              <div v-if="!mobile">
                <v-data-table
                  class="denser"
                  :headers="headers"
                  :items="payments"
                  :options.sync="options"
                  :server-items-length="total"
                  item-key="refNo"
                  :loading="paymentsLoading"
                  loading-text="Loading... Please wait"
                  :search="searchString"
                  no-data-text="All Payments and Transactions will appear here."
                  multi-sort
                  elevation="0"
                  dense
                  :footer-props="{
                    'items-per-page-options': [10, 20, 50, 100]
                  }"
                  :expanded.sync="expandedPayments"
                >
                  <template v-slot:expanded-item="{ item }">
                    <tr
                      v-for="(paymentDetailItem, index) in item.payment_details"
                      :key="`expand_${index}__${generateId()}`"
                      :class="expandedItemRow(index, item.payment_details)"
                      @click="showPayment(paymentDetailItem)"
                    >
                      <td></td>
                      <td>
                        <p class="caption">
                          {{ paymentDetailItem.refNo }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{ paymentDetailItem.dateUpdated }}
                        </p>
                      </td>
                      <!-- <td class="text-overflow"><p class="caption">{{item.tenantName}}</p></td> -->
                      <td>
                        <p class="caption">
                          {{ paymentDetailItem.category }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{ paymentDetailItem.period }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{ paymentDetailItem.dueDate }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{ formatCurrency(paymentDetailItem.total) }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{
                            formatCurrency(
                              paymentDetailItemAmountPaid(
                                paymentDetailItem,
                                item.paidPaymentId
                              )
                            )
                          }}
                        </p>
                      </td>
                      <td>
                        <p
                          :class="
                            paymentStatusClass(paymentDetailItem.raw_status)
                          "
                        >
                          {{ paymentDetailItem.status }}
                        </p>
                      </td>
                      <td>
                        <div class="d-flex flex-row">
                          <v-tooltip
                            v-if="
                              paymentDetailItem.status &&
                              (paymentDetailItem.status.toLowerCase() ===
                                'pending' ||
                                paymentDetailItem.status.toLowerCase() ===
                                  'partial payment') &&
                              paidpaymentAccess.create
                            "
                            bottom
                            dark
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                color="primary"
                                x-small
                                :disabled="!paidpaymentAccess.create"
                                @click.stop="setPaid(paymentDetailItem)"
                                v-on="on"
                              >
                                <v-icon>mdi-check-decagram</v-icon>
                              </v-btn>
                            </template>
                            <span style="color: white">Payment Received</span>
                          </v-tooltip>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:item="{ expand, item, isExpanded, index }">
                    <tr
                      v-if="item.paidPaymentId"
                      :key="index"
                      :class="paidItemRow(isExpanded)"
                      @click="showPaidPayment(item)"
                    >
                      <td>
                        <v-btn
                          v-if="!isExpanded"
                          icon
                          x-small
                          @click.stop="expand(true)"
                          ><v-icon small>mdi-chevron-down</v-icon></v-btn
                        >
                        <v-btn
                          v-if="isExpanded"
                          icon
                          x-small
                          @click.stop="expand(false)"
                          ><v-icon small>mdi-chevron-up</v-icon></v-btn
                        >
                      </td>
                      <td>
                        <p class="caption">
                          {{ item.refNo }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{ item.date }}
                        </p>
                      </td>
                      <!-- <td class="text-overflow"><p class="caption">{{item.tenantName}}</p></td> -->
                      <td>
                        <p class="caption">
                          {{ item.category }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{ item.period }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{ item.dueDate }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{ formatCurrency(item.total) }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{ formatCurrency(item.amount) }}
                        </p>
                      </td>
                      <td>
                        <div class="d-flex flex-row">
                          <p :class="paymentStatusClass(item.raw_status)">
                            {{ item.status }}
                          </p>
                          <v-tooltip v-if="hasPartialPayments(item)" bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                class="ml-1"
                                color="warning"
                                x-small
                                v-on="on"
                                >mdi-alert-circle-check</v-icon
                              >
                            </template>
                            <p class="white--text">
                              Contains unpaid partial payments
                            </p>
                          </v-tooltip>
                          <v-tooltip v-if="item.total < item.amount" bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon
                                class="ml-1"
                                color="success"
                                x-small
                                v-on="on"
                                >mdi-arrow-up-bold-circle-outline</v-icon
                              >
                            </template>
                            <p class="white--text">Overpayment</p>
                          </v-tooltip>
                        </div>
                      </td>
                      <td>
                        <div v-if="item.raw_status">
                          <div
                            v-if="
                              item.raw_status !==
                              PaidPaymentStatus.PENDING_APPROVAL
                            "
                            class="d-flex flex-row"
                          >
                            <v-tooltip
                              v-if="
                                item.status.toLowerCase() != 'void' &&
                                item.status.toLowerCase() != 'void/credited' &&
                                item.status.toLowerCase() != 'canceled' &&
                                paidpaymentAccess.void
                              "
                              bottom
                              dark
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-small
                                  :disabled="!paidpaymentAccess.void"
                                  v-on="on"
                                  @click.stop="voidPaidPayment(item)"
                                >
                                  <v-icon>mdi-cash-remove</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white">Void Payment</span>
                            </v-tooltip>
                            <v-tooltip
                              v-if="
                                item.status.toLowerCase() != 'void' &&
                                item.status.toLowerCase() != 'void/credited' &&
                                item.status.toLowerCase() != 'canceled' &&
                                paidpaymentAccess.cancel
                              "
                              bottom
                              dark
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-small
                                  color="red"
                                  :disabled="!paidpaymentAccess.cancel"
                                  v-on="on"
                                  @click.stop="cancelPaidPayment(item)"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white">Cancel</span>
                            </v-tooltip>
                          </div>
                          <div v-else>
                            <v-tooltip bottom dark>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-small
                                  color="primary"
                                  :disabled="!paidpaymentAccess.approve"
                                  v-on="on"
                                  @click.stop="approvePaidPayment(item)"
                                >
                                  <v-icon>mdi-check</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white"
                                >Approve paid payment</span
                              >
                            </v-tooltip>
                            <v-tooltip bottom dark>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-small
                                  color="red"
                                  :disabled="!paidpaymentAccess.reject"
                                  v-on="on"
                                  @click.stop="
                                    rejectPaidPayment(item.paidPaymentId)
                                  "
                                >
                                  <v-icon>mdi-cancel</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white"
                                >Reject paid payment</span
                              >
                            </v-tooltip>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr
                      v-else
                      style="cursor: pointer"
                      class="tr-head"
                      @click="showPayment(item)"
                    >
                      <td></td>
                      <td>
                        <p class="caption">
                          {{ item.refNo }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{ item.date }}
                        </p>
                      </td>
                      <!-- <td class="text-overflow"><p class="caption">{{item.tenantName}}</p></td> -->
                      <td>
                        <p class="caption">
                          {{ item.category }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{ item.period }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{ item.dueDate }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{ formatCurrency(item.total) }}
                        </p>
                      </td>
                      <td>
                        <p class="caption">
                          {{ formatCurrency(item.amountPaid) }}
                        </p>
                      </td>
                      <td>
                        <p :class="paymentStatusClass(item.raw_status)">
                          {{ item.status }}
                        </p>
                      </td>
                      <td>
                        <div v-if="item.raw_status">
                          <div
                            v-if="
                              item.raw_status !== PaymentStatus.PENDING_APPROVAL
                            "
                            class="d-flex flex-row"
                          >
                            <v-tooltip
                              v-if="
                                (item.raw_status === PaymentStatus.PENDING ||
                                  item.raw_status ===
                                    PaymentStatus.PAID_PARTIAL) &&
                                paidpaymentAccess.create
                              "
                              bottom
                              dark
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  color="primary"
                                  x-small
                                  :disabled="!paidpaymentAccess.create"
                                  @click.stop="setPaid(item)"
                                  v-on="on"
                                >
                                  <v-icon>mdi-check-decagram</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white">Payment Received</span>
                            </v-tooltip>
                            <v-tooltip
                              v-if="
                                item.raw_status === PaymentStatus.PENDING &&
                                paymentrequestAccess.update
                              "
                              bottom
                              dark
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  color="primary"
                                  x-small
                                  :disabled="
                                    !paymentrequestAccess.update ||
                                    item.readonly
                                  "
                                  @click.stop="updatePayment(item)"
                                  v-on="on"
                                >
                                  <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white">Update Payment</span>
                            </v-tooltip>
                            <v-tooltip
                              v-if="
                                ![
                                  PaymentStatus.VOID,
                                  PaymentStatus.VOID_CREDIT_BALANCE,
                                  PaymentStatus.CANCELED,
                                  PaymentStatus.POSTDATED
                                ].includes(item.raw_status) &&
                                paymentrequestAccess.void
                              "
                              bottom
                              dark
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-small
                                  :disabled="
                                    !paymentrequestAccess.void || item.readonly
                                  "
                                  v-on="on"
                                  @click.stop="voidPayment(item)"
                                >
                                  <v-icon>mdi-cash-remove</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white">Void Payment</span>
                            </v-tooltip>
                            <v-tooltip
                              v-if="
                                ![
                                  PaymentStatus.VOID,
                                  PaymentStatus.VOID_CREDIT_BALANCE,
                                  PaymentStatus.CANCELED,
                                  PaymentStatus.POSTDATED
                                ].includes(item.raw_status) &&
                                paymentrequestAccess.cancel
                              "
                              bottom
                              dark
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-small
                                  color="red"
                                  :disabled="
                                    !paymentrequestAccess.cancel ||
                                    item.readonly
                                  "
                                  v-on="on"
                                  @click.stop="cancelPayment(item)"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white">Cancel</span>
                            </v-tooltip>
                          </div>
                          <div v-else>
                            <v-tooltip bottom dark>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-small
                                  color="primary"
                                  :disabled="!paymentrequestAccess.approve"
                                  v-on="on"
                                  @click.stop="approvePaymentRequest(item)"
                                >
                                  <v-icon>mdi-check</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white"
                                >Approve payment request</span
                              >
                            </v-tooltip>
                            <v-tooltip bottom dark>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  x-small
                                  color="error"
                                  :disabled="!paymentrequestAccess.reject"
                                  v-on="on"
                                  @click.stop="
                                    rejectPaymentRequest(item.paymentId)
                                  "
                                >
                                  <v-icon>mdi-cancel</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white"
                                >Reject payment request</span
                              >
                            </v-tooltip>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </div>
              <div v-else>
                <!--transactions mobile view -->
                <v-data-table
                  class="denser"
                  :headers="headers"
                  :items="payments"
                  :options.sync="options"
                  :server-items-length="total"
                  item-key="refNo"
                  :loading="paymentsLoading"
                  loading-text="Loading... Please wait"
                  :search="searchString"
                  no-data-text="All Payments and Transactions will appear here."
                  multi-sort
                  elevation="0"
                  :footer-props="{
                    'items-per-page-options': [3]
                  }"
                  dense
                  :expanded.sync="expandedPayments"
                  disable-sort
                >
                  <template v-slot:expanded-item="{ item }">
                    <v-divider></v-divider>
                    <tr
                      v-for="(paymentDetailItem, index) in item.payment_details"
                      :key="`expand_${index}__${generateId()}`"
                      :class="expandedItemRow(index, item.payment_details)"
                      @click="showPayment(paymentDetailItem)"
                    >
                      <div
                        class="d-flex flex-column pl-5 py-2"
                        @click="togglePaymentMobile(item)"
                      >
                        <div class="d-flex flex-row">
                          <v-col class="pa-0">
                            <p class="font-weight-bold body-2">
                              {{ paymentDetailItem.category }}
                            </p>
                          </v-col>
                          <v-col class="pa-0" align="end">
                            <p class="font-weight-bold body-2">
                              {{ formatCurrency(paymentDetailItem.amountPaid) }}
                            </p>
                          </v-col>
                        </div>
                        <div class="d-flex flex-row">
                          <v-col class="pa-0">
                            <p class="caption font-weight-bold">TOTAL</p>
                          </v-col>
                          <v-col class="pa-0" align="end">
                            <p class="caption">
                              {{ formatCurrency(paymentDetailItem.total) }}
                            </p>
                          </v-col>
                        </div>
                        <div class="d-flex flex-row">
                          <v-col class="pa-0">
                            <p class="caption">
                              {{ paymentDetailItem.tenantName }}
                            </p>
                          </v-col>
                          <v-col class="pa-0" align="end">
                            <p class="caption">
                              {{ paymentDetailItem.bedName }}
                            </p>
                          </v-col>
                        </div>
                        <div class="d-flex flex-row">
                          <v-col class="pa-0">
                            <p class="caption">
                              Status:
                              <span
                                :class="paymentStatusClass(item.raw_status)"
                                >{{ item.status }}</span
                              >
                            </p>
                          </v-col>
                          <v-col class="pa-0" align="end">
                            <v-tooltip
                              v-if="
                                paymentDetailItem.status &&
                                (paymentDetailItem.status.toLowerCase() ===
                                  'pending' ||
                                  paymentDetailItem.status.toLowerCase() ===
                                    'partial payment') &&
                                paidpaymentAccess.create
                              "
                              bottom
                              dark
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  color="primary"
                                  x-small
                                  :disabled="!paidpaymentAccess.create"
                                  @click.stop="setPaid(paymentDetailItem)"
                                  v-on="on"
                                >
                                  <v-icon>mdi-check-decagram</v-icon>
                                </v-btn>
                              </template>
                              <span style="color: white">Payment Received</span>
                            </v-tooltip>
                          </v-col>
                        </div>
                        <div class="d-flex flex-row">
                          <v-col class="pa-0">
                            <p class="caption">
                              {{ paymentDetailItem.period }}
                            </p>
                          </v-col>
                        </div>
                      </div>
                    </tr>
                  </template>
                  <template v-slot:item="{ item, isExpanded, index }">
                    <v-divider></v-divider>
                    <tr
                      v-if="item.paidPaymentId"
                      :key="index"
                      :class="paidItemRow(isExpanded)"
                      @click="showPaidPayment(item)"
                    >
                      <div
                        class="d-flex flex-column py-2"
                        @click.stop="togglePaymentMobile(item)"
                      >
                        <div class="d-flex flex-row">
                          <v-col class="pa-0">
                            <p class="font-weight-bold body-2">
                              {{ item.category }}
                            </p>
                          </v-col>
                          <v-col class="pa-0" align="end">
                            <p class="font-weight-bold body-2">
                              {{ formatCurrency(item.amount) }}
                            </p>
                          </v-col>
                        </div>
                        <div class="d-flex flex-row">
                          <v-col class="pa-0">
                            <p class="caption font-weight-bold">TOTAL</p>
                          </v-col>
                          <v-col class="pa-0" align="end">
                            <p class="caption">
                              {{ formatCurrency(item.total) }}
                            </p>
                          </v-col>
                        </div>
                        <div class="d-flex flex-row">
                          <v-col class="pa-0">
                            <p class="caption">
                              {{ item.tenantName }}
                            </p>
                          </v-col>
                          <v-col class="pa-0" align="end">
                            <p class="caption">
                              {{ item.bedName }}
                            </p>
                          </v-col>
                        </div>
                        <div class="d-flex flex-row">
                          <v-col class="pa-0 d-flex flex-row">
                            <p class="caption">
                              Status:
                              <span
                                :class="paymentStatusClass(item.raw_status)"
                                >{{ item.status }}</span
                              >
                            </p>
                            <v-tooltip v-if="hasPartialPayments(item)" bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  class="ml-1"
                                  color="warning"
                                  x-small
                                  v-on="on"
                                  >mdi-alert-circle-check</v-icon
                                >
                              </template>
                              <p class="white--text">
                                Contains unpaid partial payments
                              </p>
                            </v-tooltip>
                            <v-tooltip v-if="item.total < item.amount" bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  class="ml-1"
                                  color="success"
                                  x-small
                                  v-on="on"
                                  >mdi-arrow-up-bold-circle-outline</v-icon
                                >
                              </template>
                              <p class="white--text">Overpayment</p>
                            </v-tooltip>
                          </v-col>
                        </div>
                        <div class="d-flex flex-row">
                          <v-col class="pa-0">
                            <div class="d-flex flex-row justify-space-between">
                              <div v-if="item.raw_status">
                                <div
                                  v-if="
                                    item.raw_status !==
                                    PaidPaymentStatus.PENDING_APPROVAL
                                  "
                                  class="d-flex flex-row"
                                >
                                  <p class="caption">
                                    {{ item.period }}
                                  </p>
                                  <v-tooltip
                                    v-if="
                                      item.status &&
                                      item.status.toLowerCase() != 'void' &&
                                      item.status.toLowerCase() !=
                                        'void/credited' &&
                                      item.status.toLowerCase() != 'canceled' &&
                                      paidpaymentAccess.void
                                    "
                                    bottom
                                    dark
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        icon
                                        x-small
                                        :disabled="!paidpaymentAccess.void"
                                        v-on="on"
                                        @click.stop="voidPaidPayment(item)"
                                      >
                                        <v-icon>mdi-cash-remove</v-icon>
                                      </v-btn>
                                    </template>
                                    <span style="color: white"
                                      >Void Payment</span
                                    >
                                  </v-tooltip>
                                  <v-tooltip
                                    v-if="
                                      item.status &&
                                      item.status.toLowerCase() != 'void' &&
                                      item.status.toLowerCase() !=
                                        'void/credited' &&
                                      item.status.toLowerCase() != 'canceled' &&
                                      paidpaymentAccess.cancel
                                    "
                                    bottom
                                    dark
                                  >
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        icon
                                        x-small
                                        color="red"
                                        :disabled="!paidpaymentAccess.cancel"
                                        v-on="on"
                                        @click.stop="cancelPaidPayment(item)"
                                      >
                                        <v-icon>mdi-close</v-icon>
                                      </v-btn>
                                    </template>
                                    <span style="color: white">Cancel</span>
                                  </v-tooltip>
                                </div>
                                <div v-else class="d-flex flex-row">
                                  <v-tooltip bottom dark>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        icon
                                        x-small
                                        color="primary"
                                        :disabled="!paidpaymentAccess.approve"
                                        v-on="on"
                                        @click.stop="approvePaidPayment(item)"
                                      >
                                        <v-icon>mdi-check</v-icon>
                                      </v-btn>
                                    </template>
                                    <span style="color: white"
                                      >Approve paid payment</span
                                    >
                                  </v-tooltip>
                                  <v-tooltip bottom dark>
                                    <template v-slot:activator="{ on }">
                                      <v-btn
                                        icon
                                        x-small
                                        color="red"
                                        :disabled="!paidpaymentAccess.reject"
                                        v-on="on"
                                        @click.stop="
                                          rejectPaidPayment(item.paidPaymentId)
                                        "
                                      >
                                        <v-icon>mdi-cancel</v-icon>
                                      </v-btn>
                                    </template>
                                    <span style="color: white"
                                      >Reject paid payment</span
                                    >
                                  </v-tooltip>
                                </div>
                              </div>
                              <div class="d-flex flex-row align-end">
                                <v-icon>
                                  {{ togglePaymentMobileIcon }}
                                </v-icon>
                              </div>
                            </div>
                          </v-col>
                        </div>
                      </div>
                    </tr>
                    <tr
                      v-else
                      style="cursor: pointer"
                      class="tr-head"
                      @click="showPayment(item)"
                    >
                      <div class="d-flex flex-column py-2">
                        <div class="d-flex flex-row">
                          <v-col class="pa-0">
                            <p class="font-weight-bold body-2">
                              {{ item.category }}
                            </p>
                          </v-col>
                          <v-col class="pa-0" align="end">
                            <p class="font-weight-bold body-2">
                              {{ formatCurrency(item.amountPaid) }}
                            </p>
                          </v-col>
                        </div>
                        <div class="d-flex flex-row">
                          <v-col class="pa-0">
                            <p class="caption font-weight-bold">TOTAL</p>
                          </v-col>
                          <v-col class="pa-0" align="end">
                            <p class="caption">
                              {{ formatCurrency(item.total) }}
                            </p>
                          </v-col>
                        </div>
                        <div class="d-flex flex-row">
                          <v-col class="pa-0">
                            <p class="caption">
                              {{ item.tenantName }}
                            </p>
                          </v-col>
                          <v-col class="pa-0" align="end">
                            <p class="caption">
                              {{ item.bedName }}
                            </p>
                          </v-col>
                        </div>
                        <div class="d-flex flex-row">
                          <v-col class="pa-0">
                            <p class="caption">
                              Status:
                              <span
                                :class="paymentStatusClass(item.raw_status)"
                                >{{ item.status }}</span
                              >
                            </p>
                          </v-col>
                          <v-col class="pa-0" align="end">
                            <div v-if="item.raw_status">
                              <div
                                v-if="
                                  item.raw_status !==
                                  PaymentStatus.PENDING_APPROVAL
                                "
                                class="d-flex flex-row justify-end"
                              >
                                <v-tooltip
                                  v-if="
                                    (item.raw_status ===
                                      PaymentStatus.PENDING ||
                                      item.raw_status ===
                                        PaymentStatus.PAID_PARTIAL) &&
                                    paidpaymentAccess.create
                                  "
                                  bottom
                                  dark
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      icon
                                      color="primary"
                                      x-small
                                      :disabled="!paidpaymentAccess.create"
                                      @click.stop="setPaid(item)"
                                      v-on="on"
                                    >
                                      <v-icon>mdi-check-decagram</v-icon>
                                    </v-btn>
                                  </template>
                                  <span style="color: white"
                                    >Payment Received</span
                                  >
                                </v-tooltip>
                                <v-tooltip
                                  v-if="
                                    item.raw_status === PaymentStatus.PENDING &&
                                    paymentrequestAccess.update
                                  "
                                  bottom
                                  dark
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      icon
                                      color="primary"
                                      x-small
                                      :disabled="
                                        !paymentrequestAccess.update ||
                                        item.readonly
                                      "
                                      @click.stop="updatePayment(item)"
                                      v-on="on"
                                    >
                                      <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                  </template>
                                  <span style="color: white"
                                    >Update Payment</span
                                  >
                                </v-tooltip>
                                <v-tooltip
                                  v-if="
                                    ![
                                      PaymentStatus.VOID,
                                      PaymentStatus.VOID_CREDIT_BALANCE,
                                      PaymentStatus.CANCELED,
                                      PaymentStatus.POSTDATED
                                    ].includes(item.raw_status) &&
                                    paymentrequestAccess.void
                                  "
                                  bottom
                                  dark
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      icon
                                      x-small
                                      :disabled="
                                        !paymentrequestAccess.void ||
                                        item.readonly
                                      "
                                      v-on="on"
                                      @click.stop="voidPayment(item)"
                                    >
                                      <v-icon>mdi-cash-remove</v-icon>
                                    </v-btn>
                                  </template>
                                  <span style="color: white">Void Payment</span>
                                </v-tooltip>
                                <v-tooltip
                                  v-if="
                                    ![
                                      PaymentStatus.VOID,
                                      PaymentStatus.VOID_CREDIT_BALANCE,
                                      PaymentStatus.CANCELED,
                                      PaymentStatus.POSTDATED
                                    ].includes(item.raw_status) &&
                                    paymentrequestAccess.cancel
                                  "
                                  bottom
                                  dark
                                >
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      icon
                                      x-small
                                      color="red"
                                      :disabled="
                                        !paymentrequestAccess.cancel ||
                                        item.readonly
                                      "
                                      v-on="on"
                                      @click.stop="cancelPayment(item)"
                                    >
                                      <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                  </template>
                                  <span style="color: white">Cancel</span>
                                </v-tooltip>
                              </div>
                              <div v-else class="d-flex flex-row justify-end">
                                <v-tooltip bottom dark>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      icon
                                      x-small
                                      color="primary"
                                      :disabled="
                                        !paymentrequestAccess.approve ||
                                        item.readonly
                                      "
                                      v-on="on"
                                      @click.stop="approvePaymentRequest(item)"
                                    >
                                      <v-icon>mdi-check</v-icon>
                                    </v-btn>
                                  </template>
                                  <span style="color: white"
                                    >Approve payment request</span
                                  >
                                </v-tooltip>
                                <v-tooltip bottom dark>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      icon
                                      x-small
                                      color="error"
                                      :disabled="
                                        !paymentrequestAccess.reject ||
                                        item.readonly
                                      "
                                      v-on="on"
                                      @click.stop="
                                        rejectPaymentRequest(item.paymentId)
                                      "
                                    >
                                      <v-icon>mdi-cancel</v-icon>
                                    </v-btn>
                                  </template>
                                  <span style="color: white"
                                    >Reject payment request</span
                                  >
                                </v-tooltip>
                              </div>
                            </div>
                          </v-col>
                        </div>
                        <div class="d-flex flex-row">
                          <v-col class="pa-0">
                            <p class="caption">
                              {{ item.period }}
                            </p>
                          </v-col>
                        </div>
                      </div>
                    </tr>
                  </template>
                </v-data-table>
              </div>
              <div
                v-if="!mobile"
                class="table-footer-prepend d-flex pl-2 align-center"
              >
                <v-btn
                  v-if="allExpanded"
                  text
                  small
                  color="primary"
                  @click="collapseAll"
                  ><v-icon class="mr-1" small>mdi-unfold-less-horizontal</v-icon
                  >Collapse all</v-btn
                >
                <v-btn v-else text small color="primary" @click="expandAll"
                  ><v-icon class="mr-1" small>mdi-unfold-more-horizontal</v-icon
                  >Expand all</v-btn
                >
              </div>
            </div>
            <span v-else class="grey--text"
              >You are not authorized to view this content</span
            >
          </v-card>
          <v-skeleton-loader
            v-else
            ref="skeleton"
            type="table"
            loading
            class="mx-auto"
          ></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <div
            :class="{
              'card-label': true,
              'd-flex': true,
              'flex-row': true,
              'mb-4': true,
              'justify-space-between': true
            }"
          >
            <div class="d-flex flex-row">
              <v-icon>mdi-cash-multiple</v-icon>
              <p class="mb-0 ml-4 subtitle-2 font-weight-bold">
                Post Dated Checks
              </p>
            </div>
            <div class="d-flex flex-row align-center">
              <v-btn
                depressed
                rounded
                :small="!mobile"
                :x-small="mobile"
                :class="{ 'mr-2': mobile }"
                color="primary"
                :disabled="!paymentrequestAccess.create"
                @click="openAddPDC"
              >
                <v-icon small :class="{ 'pr-1': !mobile }">mdi-plus</v-icon
                ><span v-if="!mobile" class="white--text"> Add a PDC</span>
              </v-btn>
              <v-btn
                v-if="showPDCsCard"
                text
                :small="!mobile"
                :x-small="mobile"
                :class="{ 'ml-2': !mobile }"
                color="primary"
                @click="togglePDCsCard"
                ><v-icon small class="pr-1">mdi-eye-off</v-icon>Hide</v-btn
              >
              <v-btn
                v-else
                text
                :small="!mobile"
                :x-small="mobile"
                :class="{ 'ml-2': !mobile }"
                color="primary"
                @click="togglePDCsCard"
                ><v-icon small class="pr-1">mdi-eye</v-icon>Show</v-btn
              >
            </div>
          </div>
          <!-- PDC -->
          <PDCTable
            :search-trigger="PDCSearchTrigger"
            :lease-id="bedDetails.leaseId"
            type="unit"
            @PDCReload="reload"
          ></PDCTable>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <div
            :class="{
              'card-label': true,
              'd-flex': true,
              'flex-row': true,
              'mb-4': true,
              'justify-space-between': true
            }"
          >
            <div class="d-flex flex-row mb-2">
              <v-icon>mdi-cash-lock</v-icon>
              <p class="mb-0 ml-4 subtitle-2 font-weight-bold">
                Security Deposits
              </p>
            </div>
            <div class="d-flex flex-row align-center">
              <v-btn
                depressed
                rounded
                :small="!mobile"
                :x-small="mobile"
                :class="{ 'mr-2': mobile }"
                color="primary"
                :disabled="!securityDepositAccess.create"
                @click="createSecurityDeposit"
              >
                <v-icon small :class="{ 'pr-1': !mobile }">mdi-plus</v-icon
                ><span v-if="!mobile" class="white--text"
                  >Add a security deposit</span
                >
              </v-btn>
            </div>
          </div>
          <div v-if="bedDetails.leaseId">
            <security-deposit-table
              :search-string="searchString"
              :lease-id="bedDetails.leaseId"
              :search-trigger="securityDepositSearchTrigger"
              type="unit"
              @securityDepositReload="reload"
            ></security-deposit-table>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <div
            :class="{
              'card-label': true,
              'd-flex': true,
              'flex-row': true,
              'mb-4': true,
              'justify-space-between': true
            }"
          >
            <div class="d-flex flex-row mb-2">
              <v-icon>mdi-attachment</v-icon>
              <p class="mb-0 ml-4 subtitle-2 font-weight-bold">Attachments</p>
            </div>
            <div class="d-flex flex-row align-center">
              <v-btn
                depressed
                rounded
                :small="!mobile"
                :x-small="mobile"
                :class="{ 'mr-2': mobile }"
                color="primary"
                @click="addAttachments"
              >
                <v-icon small :class="{ 'pr-1': !mobile }">mdi-plus</v-icon
                ><span v-if="!mobile" class="white--text">
                  Upload Attachments</span
                >
              </v-btn>
            </div>
          </div>
          <v-card
            v-if="!detailsLoading"
            :class="{
              'card-container': true,
              'card-container': true,
              'px-8': !mobile,
              'py-4': !mobile,
              'px-4': mobile,
              'py-2': mobile,
              'elevation-0': true
            }"
          >
            <div>
              <v-chip-group multiple column class="pt-0">
                <v-chip
                  v-for="(attachment, index) in bedDetails.attachments"
                  :key="index"
                  close
                  outlined
                  color="primary"
                  :href="attachment.url"
                  :class="{ 'mx-2': !mobile }"
                  @click:close="deleteAttachment(attachment)"
                >
                  <div class="chip-label">
                    {{ attachment.filename }}
                  </div>
                </v-chip>
              </v-chip-group>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-divider class="my-4"></v-divider>

      <v-row>
        <v-col cols="12" sm="12" md="12">
          <div
            :class="{
              'card-label': true,
              'd-flex': true,
              'flex-row': true,
              'mb-4': true,
              'justify-space-between': true
            }"
          >
            <div class="d-flex flex-row mb-2">
              <v-icon>mdi-alert</v-icon>
              <p class="mb-0 ml-4 subtitle-2 font-weight-bold">Danger Zone</p>
            </div>
          </div>

          <div class="text-center">
            <v-btn
              class="ma-2"
              color="warning"
              depressed
              large
              :disabled="!access.preterminate || bedDetails.preTerminated"
              @click="preterminate"
            >
              Pre-terminate lease
              <v-icon right dark> mdi-book-cancel-outline </v-icon>
            </v-btn>
            <v-btn
              class="ma-2"
              color="error"
              depressed
              large
              :disabled="!access.delete"
              @click="terminate"
            >
              Terminate lease
              <v-icon right dark> mdi-exit-to-app </v-icon></v-btn
            >
          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-speed-dial
      v-model="fab"
      right
      bottom
      direction="top"
      fixed
      transition="slide-y-reverse-transition"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark fab :x-small="mobile">
          <v-icon v-if="fab" :small="mobile">mdi-close</v-icon>
          <v-icon v-else :small="mobile">mdi-dots-horizontal</v-icon>
        </v-btn>
      </template>

      <v-tooltip v-if="access.update" left dark>
        <template v-slot:activator="{ on }">
          <v-btn fab dark color="red" small v-on="on" @click="terminate">
            <v-icon small>mdi-exit-to-app</v-icon>
          </v-btn>
        </template>
        <span style="color: white">Terminate lease</span>
      </v-tooltip>

      <v-tooltip v-if="access.update" left dark>
        <template v-slot:activator="{ on }">
          <v-btn fab dark color="blue" small v-on="on" @click="transferTenant">
            <v-icon small>mdi-account-arrow-right</v-icon>
          </v-btn>
        </template>
        <span style="color: white">Transfer</span>
      </v-tooltip>

      <v-tooltip v-if="paymentAccess.statement" left dark>
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            color="light-green"
            small
            v-on="on"
            @click="generateMonthlyStatement"
          >
            <v-icon small>mdi-file-chart</v-icon>
          </v-btn>
        </template>
        <span style="color: white">Generate Month-to-date Statement</span>
      </v-tooltip>

      <v-tooltip v-if="access.update" left dark>
        <template v-slot:activator="{ on }">
          <v-btn fab dark color="pink" small v-on="on" @click="renewLease">
            <v-icon small>mdi-autorenew</v-icon>
          </v-btn>
        </template>
        <span style="color: white">Update Lease Period</span>
      </v-tooltip>

      <v-tooltip v-if="paidpaymentAccess.waive" left dark>
        <template v-slot:activator="{ on }">
          <v-btn class="orange" fab dark small v-on="on" @click="waiveFees">
            <v-icon small>mdi-file-cancel</v-icon>
          </v-btn>
        </template>
        <span style="color: white">Waive Rental Fee</span>
      </v-tooltip>

      <v-tooltip v-if="paidpaymentAccess.create" left dark>
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            color="cyan"
            small
            v-on="on"
            @click="openCombinedPayments"
          >
            <v-icon small>mdi-calculator</v-icon>
          </v-btn>
        </template>
        <span style="color: white">Create Combined Payment</span>
      </v-tooltip>

      <v-tooltip v-if="paymentAccess.statement" left dark>
        <template v-slot:activator="{ on }">
          <v-btn fab dark color="yellow" small v-on="on" @click="generateSOA">
            <v-icon small>mdi-file-document</v-icon>
          </v-btn>
        </template>
        <span style="color: white">Generate Statement of Account</span>
      </v-tooltip>

      <v-tooltip v-if="paymentrequestAccess.create" left dark>
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            color="indigo"
            small
            v-on="on"
            @click="collectUtilities"
          >
            <v-icon small>mdi-cash-plus</v-icon>
          </v-btn>
        </template>
        <span style="color: white">Create Payment Request</span>
      </v-tooltip>

      <v-tooltip v-if="paidpaymentAccess.create" left dark>
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-btn
              fab
              :dark="!paymentCompleted"
              color="green"
              small
              :disabled="paymentCompleted"
              @click="collectRentalPayment"
            >
              <v-icon small>mdi-bed</v-icon>
            </v-btn>
          </div>
        </template>

        <span v-if="bedDetails.preTerminated" style="color: white"
          >Pre-terminated</span
        >
        <span v-else-if="paymentCompleted" style="color: white"
          >Payment Completed</span
        >
        <span v-else style="color: white">Collect Rental Payment</span>
      </v-tooltip>

      <v-tooltip
        v-if="
          paymentrequestAccess.create && rentalsToMake && rentalsToMake.length
        "
        left
        dark
      >
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            color="teal"
            small
            v-on="on"
            @click="catchUpPendingRentals"
          >
            <v-icon small>mdi-run-fast</v-icon>
          </v-btn>
        </template>
        <span style="color: white">Catch Up Pending Rentals</span>
      </v-tooltip>
    </v-speed-dial>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
    <Invoice ref="invoice"></Invoice>
    <CollectUtilities ref="collectUtilities"></CollectUtilities>
    <CollectRentalPayment ref="collectRentalPayment"></CollectRentalPayment>
    <Terminate ref="terminate"></Terminate>
    <Preterminate ref="preterminate"></Preterminate>
    <RenewLease ref="renewLease"></RenewLease>
    <AddAttachments ref="addAttachments"></AddAttachments>
    <TransferTenant ref="transferTenant"></TransferTenant>
    <ConfirmPayment ref="confirmPayment"></ConfirmPayment>
    <VoidPayment ref="voidPayment"></VoidPayment>
    <VoidPaidPayment ref="voidPaidPayment"></VoidPaidPayment>
    <CancelPayment ref="cancelPayment"></CancelPayment>
    <CancelPaidPayment ref="cancelPaidPayment"></CancelPaidPayment>
    <WaiveFees ref="waiveFees"></WaiveFees>
    <!-- <AddBedContact ref="addBedContact"></AddBedContact>
    <UpdateBedContact ref="updateBedContact"></UpdateBedContact> -->
    <GenerateReport ref="generateReport"></GenerateReport>
    <UpdatePaymentRequest ref="updatePaymentRequest"></UpdatePaymentRequest>
    <CatchUpPendingRentals ref="catchUpPendingRentals"></CatchUpPendingRentals>
    <CombinedPayments ref="combinedPayments"></CombinedPayments>
    <EditUnitTags ref="editUnitTags" @addTag="onAddTag"></EditUnitTags>
    <ApprovePaymentRequest ref="approvePaymentRequest"></ApprovePaymentRequest>
    <ApprovePaidPayment ref="approvePaidPayment"></ApprovePaidPayment>
    <create-security-deposit
      ref="createSecurityDeposit"
      @reload="reload"
    ></create-security-deposit>
    <generate-month-to-date-statement
      ref="generateMonthToDateStatement"
      @snack="showSnackbar"
    ></generate-month-to-date-statement>
    <paid-payment-invoice ref="paidPaymentInvoice"></paid-payment-invoice>
  </div>
</template>

<script>
import { dayjs, FULLDATE } from '../util/date'
import { nanoid } from 'nanoid/non-secure'
import Hashids from 'hashids'
import OnTimeRate from '../components/units/OnTimeRate'
import CollectUtilities from '../components/units/CollectUtilities.vue'
import CollectRentalPayment from '../components/payment/CollectRentalPayment.vue'
import Terminate from '../components/units/Terminate/Terminate.vue'
import Preterminate from '../components/units/Terminate/Preterminate.vue'
import TransferTenant from '../components/units/TransferTenant.vue'
import RenewLease from '../components/units/RenewLease.vue'
import AddAttachments from '../components/units/AddAttachments.vue'
import Invoice from '../components/Invoice.vue'
import ConfirmPayment from '../components/payment/ConfirmPayment.vue'
import VoidPayment from '../components/payment/VoidPayment.vue'
import VoidPaidPayment from '../components/payment/VoidPaidPayment.vue'
import CancelPayment from '../components/payment/CancelPayment.vue'
import CancelPaidPayment from '../components/payment/CancelPaidPayment.vue'
import WaiveFees from '../components/units/WaiveFees.vue'
import GenerateReport from '../components/payment/GenerateReport.vue'
import UpdatePaymentRequest from '../components/units/UpdatePaymentRequest.vue'
import CatchUpPendingRentals from '../components/payment/CatchUpPendingRentals.vue'
import CombinedPayments from '../components/payment/CombinedPayments.vue'
import EditUnitTags from '../components/units/EditUnitTags'
import ApprovePaymentRequest from '../components/payment/ApprovePaymentRequest.vue'
import ApprovePaidPayment from '../components/payment/ApprovePaidPayment.vue'
import { PaymentStatus, PaidPaymentStatus } from '../config/payment'
import SecurityDepositTable from '../components/tables/SecurityDepositTable.vue'
import CreateSecurityDeposit from '../components/securityDeposit/CreateSecurityDeposit.vue'
import GenerateMonthToDateStatement from '../components/units/GenerateMonthToDateStatement.vue'
import PaidPaymentInvoice from '../components/payment/PaidPaymentInvoice.vue'
import PDCTable from '../components/tables/PDCTable.vue'

const hashids = new Hashids()

export default {
  components: {
    OnTimeRate,
    CollectUtilities,
    CollectRentalPayment,
    Terminate,
    Preterminate,
    RenewLease,
    AddAttachments,
    TransferTenant,
    Invoice,
    ConfirmPayment,
    VoidPayment,
    CancelPayment,
    CancelPaidPayment,
    VoidPaidPayment,
    WaiveFees,
    GenerateReport,
    UpdatePaymentRequest,
    CatchUpPendingRentals,
    CombinedPayments,
    EditUnitTags,
    ApprovePaymentRequest,
    ApprovePaidPayment,
    SecurityDepositTable,
    CreateSecurityDeposit,
    GenerateMonthToDateStatement,
    PaidPaymentInvoice,
    PDCTable
  },
  props: ['bedId'],
  data() {
    return {
      fab: false,
      limit: 0,
      total: 0,
      loading: true,
      detailsLoading: true,
      options: {},
      searchString: '',
      onTimeData: {
        labels: [],
        datasets: [
          {
            label: 'Days Early',
            fill: false,
            backgroundColor: '#00c3e3',
            borderColor: '#00c3e3',
            data: []
          }
        ]
      },
      // chartData: [],
      loaded: false,
      item: {},
      pendingBalance: 0,
      paymentsLoading: true,
      PaymentStatus,
      showPaymentsCard: true,
      showPDCsCard: true,
      previewDialog: false,
      selectedItem: {},
      notesBox: false,
      notes: '',
      lastSavedNotes: '',
      areaBox: false,
      area: '',
      lastSavedArea: '',
      showUpdateRentFee: false,
      rentFee: '',
      lastSavedRentFee: '',
      contractPeriods: [],
      showUpdateAlias: false,
      alias: '',
      lastSavedAlias: '',
      showUpdateTenantContact: '',
      tenantContact: '',
      lastSavedTenantContact: '',
      phMobileRules: [
        (v) => {
          const pattern = /^(\+639)\d{9}$/
          return pattern.test(v) || !v || 'Please use the format +63xxxxxxxxxx'
        }
      ],
      showUpdateDueDate: false,
      dueDate: '',
      lastSavedDueDate: '',
      dueDateMenu: false,
      dueDatePicker: '',
      rentalsToMake: [],
      showAmountDue: false,
      expandedPayments: [],
      allExpanded: false,
      sendNotification: true,
      isNumberValid: false,
      showUpdateRentalPeriod: false,
      updateNextRentalStartDate: null,
      updateNextRentalStartDateMenu: false,
      updateNextRentalEndDate: null,
      togglePaymentMobileIcon: 'mdi-chevron-down',
      snackbar: false,
      snackbarText: '',
      PaidPaymentStatus,
      securityDepositSearchTrigger: false,
      PDCSearchTrigger: false,
      unpaidPreviousRentalPaymentRequests: []
    }
  },
  computed: {
    bedDetails() {
      const bedDetails = this.$store.getters['units/getSelectedBed']
      // set [] if undefined for the observer to detect it
      if (!bedDetails.tags) bedDetails.tags = []
      return bedDetails
    },
    payments() {
      return this.$store.getters['payments/getBedPayments']
    },
    bedChartPayments() {
      return this.$store.getters['payments/getBedChartPayments']
    },
    headers() {
      return this.$store.getters['payments/getHeaders'].filter(
        (h) => h.value !== 'tenantName'
      )
    },
    getTenantName() {
      if (this.lastSavedAlias != null) {
        return this.lastSavedAlias
      }
      if (this.bedDetails.tenant_details) {
        const alias = this.bedDetails.tenantAlias
        if (alias) {
          return alias
        } else if (
          this.bedDetails.tenant_details.firstName &&
          this.bedDetails.tenant_details.lastName
        ) {
          return (
            this.bedDetails.tenant_details.firstName +
            ' ' +
            this.bedDetails.tenant_details.lastName
          )
        } else {
          return this.bedDetails.tenant_details.username
        }
      }
      return 'N/A'
    },
    getTenantNameWithUsername() {
      if (this.lastSavedAlias != null) {
        return this.lastSavedAlias
      }
      if (this.bedDetails.tenant_details) {
        const alias = this.bedDetails.tenantAlias
        let name = ''
        if (alias) {
          return alias
        }
        if (this.bedDetails.tenant_details.firstName) {
          name += this.bedDetails.tenant_details.firstName + ' '
        }
        if (this.bedDetails.tenant_details.lastName) {
          name += this.bedDetails.tenant_details.lastName + ' '
        }
        if (this.bedDetails.tenant_details.username) {
          name += `(${this.bedDetails.tenant_details.username})`
        }
        return name
      }
      return 'N/A'
    },
    getProfilePicture() {
      if (this.bedDetails.tenant_details) {
        if (this.bedDetails.tenant_details.profilePicture) {
          return this.bedDetails.tenant_details.profilePicture
        }
      }
      return ''
    },
    property() {
      return this.$store.getters['properties/getProperty']
    },
    dueDateColor() {
      const today = dayjs().hour(0).minute(0).second(0).millisecond(0)
      if (this.paymentCompleted) return 'body-2 font-weight-bold grey--text'
      if (
        today.isAfter(dayjs(this.bedDetails.paidUntilDate).subtract(1, 'day'))
      ) {
        return 'body-2 font-weight-bold red--text'
      }
      return 'body-2 font-weight-bold'
    },
    access() {
      return this.$root.$roleAccess('lease').access
    },
    paymentAccess() {
      return this.$root.$roleAccess('payment').access
    },
    aliases() {
      return this.$store.getters['users/getAliases']
    },
    amountDue() {
      return this.pendingBalance - this.bedDetails.balance
    },
    paymentrequestAccess() {
      return this.$root.$roleAccess('paymentrequest').access
    },
    paidpaymentAccess() {
      return this.$root.$roleAccess('paidpayment').access
    },
    securityDepositAccess() {
      return this.$root.$roleAccess('security_deposit').access
    },
    nextRentalStartDate() {
      if (
        this.bedDetails.nextRentalPeriod &&
        this.bedDetails.nextRentalPeriod.startDate
      ) {
        return this.bedDetails.nextRentalPeriod.startDate
      } else {
        return this.bedDetails.paidUntilDate
      }
    },
    nextRentalEndDate() {
      if (
        this.bedDetails.nextRentalPeriod &&
        this.bedDetails.nextRentalPeriod.endDate
      ) {
        return this.bedDetails.nextRentalPeriod.endDate
      }
      return dayjs(this.nextRentalStartDate)
        .add(1, 'month')
        .subtract(1, 'day')
        .format()
    },
    mobile() {
      return this.$vuetify.breakpoint.xs
    },
    alignRentDetails() {
      return (this.mobile && 'end') || ''
    },
    paymentCompleted() {
      return this.nextRentalStartDate > this.bedDetails.endOfLease
    },
    unpaidPreviousRentalPaymentRequestsRefNoList() {
      const listOfRefNos = this.unpaidPreviousRentalPaymentRequests.map(
        (paymentRequest) => `#${paymentRequest.refNo}`
      )

      return listOfRefNos.join(', ')
    }
  },
  watch: {
    options: {
      async handler() {
        await this.fetchBedPayments()
      }
    },
    updateNextRentalStartDate: function (newStartDate) {
      this.updateNextRentalEndDate = dayjs(newStartDate)
        .add(1, 'month')
        .subtract(1, 'day')
        .format('YYYY-MM-DD')
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    async reload() {
      this.loading = true
      this.detailsLoading = true
      let bedPaymentsData = null
      try {
        bedPaymentsData = await this.$store.dispatch(
          'units/fetchSelectedBedAction',
          hashids.decode(this.bedId)
        )
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
        this.$router.push('/units')
      }
      // set bed details first
      this.lastSavedNotes = this.bedDetails.notes
      this.lastSavedArea = this.bedDetails.area
      this.notes = this.bedDetails.notes
      this.area = this.bedDetails.area
      this.lastSavedRentFee = this.bedDetails.rentFee
      this.rentFee = this.bedDetails.rentFee
      this.lastSavedAlias = this.bedDetails.tenantAlias
      this.alias = this.bedDetails.tenantAlias
      this.lastSavedTenantContact = this.bedDetails.tenantContact
      this.tenantContact =
        this.bedDetails.tenantContact ||
        this.bedDetails.tenant_details.contactNumber1
      this.lastSavedDueDate = dayjs(this.bedDetails.paidUntilDate).format(
        'MMMM D, YYYY'
      )
      this.dueDate = dayjs(this.bedDetails.paidUntilDate).format('YYYY-MM-DD')
      this.sendNotification = this.bedDetails.sendNotification
      if (this.bedDetails.contractPeriods) {
        this.contractPeriods = this.bedDetails.contractPeriods.map((c) => {
          if (
            dayjs(c.moveInDate).isSame(this.bedDetails.moveInDate) &&
            dayjs(c.moveOutDate).isSame(this.bedDetails.moveOutDate)
          ) {
            c.active = true
          } else {
            c.active = false
          }
          return c
        })
      } else {
        this.contractPeriods = [
          {
            moveInDate: this.bedDetails.moveInDate,
            moveOutDate: this.bedDetails.moveOutDate,
            rentFee: this.bedDetails.rentFee,
            active: true
          }
        ]
      }
      this.detailsLoading = false

      // call secondary data
      // 1. rentals to make
      // 2. bed pdcs
      // 3. bed chart
      // 4. payments
      const paymentActions = [
        this.$store.dispatch('payments/fetchRentalsToMakeAction', {
          leaseId: this.bedDetails.leaseId
        }),
        this.$store.dispatch('payments/fetchBedChartPaymentsAction', {
          leaseId: this.bedDetails.leaseId,
          tenantId: this.bedDetails.tenantId
        }),
        this.fetchBedPayments(),
        this.$store.dispatch('payments/fetchBalanceAction', {
          userId: this.bedDetails.tenantId
        }),
        this.reloadSecurityDeposit(),
        this.reloadPDC()
      ]
      const paymentActionsValues = await Promise.all(paymentActions)
      this.rentalsToMake = paymentActionsValues[0]
      this.limit = bedPaymentsData.limit
      this.total = bedPaymentsData.count

      if (Number.isInteger(this.bedDetails.tenantId)) {
        this.pendingBalance = paymentActionsValues[3]
        this.onTimeData.labels = await this.bedChartPayments.map(
          (payment) => payment.startDate
        )
        this.onTimeData.datasets[0].data = await this.bedChartPayments.map(
          (payment) => payment.diffDate
        )
        // this.chartData = this.bedChartPayments.map(payment => payment.diffDate)
        this.loaded = true
        this.loading = false
      }

      // lazy load
      this.unpaidPreviousRentalPaymentRequests =
        await this.fetchUnpaidPreviousRentalPaymentRequests()
    },
    async fetchBedPayments() {
      this.paymentsLoading = true
      await this.$store
        .dispatch('payments/fetchBedPaymentsAction', {
          page: this.options.page,
          limit: this.options.itemsPerPage,
          sortBy: this.options.sortBy,
          sortDesc: this.options.sortDesc,
          leaseId: this.bedDetails.leaseId,
          tenantId: this.bedDetails.tenantId
        })
        .then((data) => {
          this.paymentsLoading = false
          this.limit = data.limit
          this.total = data.count
          if (this.allExpanded) {
            this.expandedPayments = this.payments
          } else {
            this.expandedPayments = []
          }
        })
    },
    updateData() {
      this.$refs.onTimeChart.update()
    },
    reloadSecurityDeposit() {
      this.securityDepositSearchTrigger = !this.securityDepositSearchTrigger
    },
    reloadPDC() {
      this.PDCSearchTrigger = !this.PDCSearchTrigger
    },
    collectUtilities() {
      this.$refs.collectUtilities.open(this.bedDetails).then(() => {
        // this.$router.go()
        // window.location.reload()
        this.reload()
      })
    },
    collectRentalPayment() {
      this.$refs.collectRentalPayment.open(this.bedDetails).then((success) => {
        if (success) this.reload()
      })
    },
    terminate() {
      this.$refs.terminate.open(this.bedDetails).then(() => {
        this.$router.replace('/units')
      })
    },
    preterminate() {
      this.$refs.preterminate.open(this.bedDetails).then(() => {
        this.reload()
      })
    },
    transferTenant() {
      this.$refs.transferTenant.open(this.bedDetails).then(() => {
        this.$router.replace('/units')
      })
    },
    renewLease() {
      this.$refs.renewLease.open(this.bedDetails)
    },
    addAttachments() {
      this.$refs.addAttachments.open(this.bedDetails)
    },
    deleteAttachment(attachment) {
      this.$root
        .$confirm({
          title: 'Delete Attachment',
          message: 'Are you sure you want to delete this attachment?',
          confirmText: 'CONFIRM',
          options: {
            color: 'primary'
          }
        })
        .then(async (resolve) => {
          if (resolve) {
            //"CONFIRM" was pressed
            const params = {
              leaseId: this.bedDetails.leaseId,
              attachment: attachment
            }
            await this.$store.dispatch('units/deleteAttachmentAction', params)
            this.reload()
          }
        })
    },
    async generateSOA() {
      this.$root.$setLoading(true)
      const asyncJob = await this.$store.dispatch(
        'asyncJobs/createSOAAsyncJob',
        {
          tenantId: this.bedDetails.tenant_details.userId
        }
      )
      this.$root.$setLoading(false)
      if (!asyncJob || !asyncJob.jobId) {
        this.$root.$confirm({
          title: 'Error',
          message: 'Failed to generate Statement of Account. Please try again.',
          options: {
            color: 'error'
          }
        })
        return
      }
      this.$router.push(`/asyncJobs/${asyncJob.jobId}`)
    },
    async setPaid(item) {
      this.$refs.confirmPayment.open(item).then(() => {
        this.reload()
      })
    },
    getPaymentStatus(bedDetails) {
      const nextCollection = dayjs(bedDetails.paidUntilDate)
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0)
      const today = dayjs().hour(0).minute(0).second(0).millisecond(0)

      if (nextCollection.isBefore(today, 'date')) {
        return 'Overdue'
      }
      if (nextCollection.isSame(today, 'day')) {
        return 'Due Today'
      }
      if (nextCollection.isAfter(today, 'date')) {
        return 'Upcoming'
      }
    },
    statusColor(bedDetails) {
      const nextCollection = dayjs(bedDetails.paidUntilDate)
        .hour(0)
        .minute(0)
        .second(0)
        .millisecond(0)
      const today = dayjs().hour(0).minute(0).second(0).millisecond(0)

      if (nextCollection.isBefore(today, 'date')) {
        return 'color: red'
      }
      if (nextCollection.isSame(today, 'day')) {
        return 'color: red'
      }
      if (nextCollection.isAfter(today, 'date')) {
        return 'color: black'
      }
    },
    redirectUser() {
      if (!this.loading) {
        this.loading = true
        this.$router.push(`/user/${this.bedDetails.tenant_details.username}`)
      }
    },
    showPayment(item) {
      this.$refs.invoice.open({ item: item })
    },
    showPaidPayment(item) {
      if (this.$refs.paidPaymentInvoice)
        this.$refs.paidPaymentInvoice.open({ item })
    },
    formatCurrency(value) {
      if (value == null) return ''
      return parseFloat(value / 100).toLocaleString('en-PH', {
        style: 'currency',
        currency: 'PHP'
      })
    },
    voidPayment(item) {
      this.$refs.voidPayment.open(item).then(() => {
        this.reload()
      })
    },
    cancelPayment(item) {
      this.$refs.cancelPayment.open(item).then(() => {
        this.reload()
      })
    },
    waiveFees() {
      this.$refs.waiveFees.open(this.bedDetails).then(() => {
        this.reload()
      })
    },
    // addBedContact() {
    //   this.$refs.addBedContact.open(this.bedDetails.tenantId)
    // },
    // updateBedContact() {
    //   this.$refs.updateBedContact.open({tenantId: this.bedDetails.tenantId, contact: this.bedDetails.tenantContact})
    // },
    async resendActivation(userId) {
      this.loading = true
      await this.$store.dispatch('users/resendActivationAction', {
        userId: userId
      })

      this.$root.$confirm({
        title: 'Resend Activation',
        message: `The activation email has been resent.`,
        reconfirmOnly: true,
        confirmText: 'OK'
      })
      this.loading = false
    },
    openGenerateReportDialog() {
      this.$refs.generateReport.open({
        tenantId: this.bedDetails.tenant_details.userId
      })
    },
    togglePaymentsCard() {
      this.showPaymentsCard = !this.showPaymentsCard
    },
    togglePDCsCard() {
      this.showPDCsCard = !this.showPDCsCard
    },
    openAddPDC() {
      this.$router.push('/addMultiplePDC')
    },
    showNotesBox() {
      this.notesBox = true
    },
    hideNotesBox() {
      this.notesBox = false
    },
    async saveNotes() {
      await this.$store.dispatch('units/saveNotesAction', {
        leaseId: this.bedDetails.leaseId,
        bedId: this.bedDetails.bedId,
        notes: this.notes
      })
      this.lastSavedNotes = this.notes
      this.notesBox = false
    },
    showAreaBox() {
      this.areaBox = true
    },
    hideAreaBox() {
      this.areaBox = false
    },
    async saveArea() {
      await this.$store.dispatch('units/saveAreaAction', {
        bedId: hashids.decode(this.bedId),
        area: this.area
      })
      this.lastSavedArea = this.area
      this.areaBox = false
    },
    async redirectLinkUnitsDocumentation() {
      window.open('https://docs.spacepack.ph/units#link-units', '_blank')
    },
    setShowUpdateRentFee() {
      this.showUpdateRentFee = !this.showUpdateRentFee
    },
    async updateRentFee() {
      this.loading = true
      await this.$store.dispatch('units/saveRentFeeAction', {
        leaseId: this.bedDetails.leaseId,
        rentFee: this.rentFee
      })
      this.lastSavedRentFee = this.rentFee
      this.showUpdateRentFee = false
      this.reload()
      await this.updateUnitsFlat()
      this.loading = false
    },
    getAlias(tenantId) {
      const alias = this.aliases.find((a) => a.tenantId === tenantId)

      return alias && alias.name
    },
    setShowUpdateAlias() {
      this.showUpdateAlias = !this.showUpdateAlias
    },
    async updateAlias() {
      this.loading = true
      await this.$store.dispatch('users/updateAliasAction', {
        propertyId: this.property.propertyId,
        tenantId: this.bedDetails.tenantId,
        name: this.alias
      })

      this.lastSavedAlias = this.alias
      this.showUpdateAlias = false
      this.reload()
      await this.updateUnitsFlat()
      this.loading = false
    },
    setShowUpdateTenantContact() {
      this.showUpdateTenantContact = !this.showUpdateTenantContact
    },
    async updateTenantContact() {
      this.loading = true
      await this.$store.dispatch('units/updateBedContactAction', {
        contact: this.tenantContact,
        tenantId: this.bedDetails.tenantId
      })

      this.lastSavedTenantContact = this.tenantContact
      this.showUpdateTenantContact = false
      this.reload()
      await this.updateUnitsFlat()
      this.loading = false
    },
    setShowUpdateDueDate() {
      this.showUpdateDueDate = !this.showUpdateDueDate
    },
    async updateDueDate() {
      this.loading = true
      await this.$store.dispatch('units/updateDueDateAction', {
        dueDate: dayjs(this.dueDate).format(),
        leaseId: this.bedDetails.leaseId
      })

      this.lastSavedDueDate = dayjs(this.dueDate).format('MMMM D, YYYY')
      this.showUpdateDueDate = false
      this.reload()
      await this.updateUnitsFlat()
      this.loading = false
    },
    formatDate(date) {
      return dayjs(date).format('MMMM D, YYYY')
    },
    async updateUnitsFlat() {
      await this.$store.dispatch('units/fetchUnitsFlatAction', {
        propertyId: this.property.propertyId
      })
    },
    async updatePayment(item) {
      this.$refs.updatePaymentRequest.open(item).then(async () => {
        this.reload()
      })
    },
    paymentStatusClass(status) {
      if (
        [PaymentStatus.PENDING, PaymentStatus.PENDING_APPROVAL].includes(status)
      ) {
        return 'red--text caption'
      } else {
        return 'caption'
      }
    },
    catchUpPendingRentals() {
      this.$refs.catchUpPendingRentals
        .open({
          rentalsToMake: this.rentalsToMake,
          bedDetails: this.bedDetails
        })
        .then((success) => {
          if (success) this.reload()
        })
    },
    openCombinedPayments() {
      this.$refs.combinedPayments
        .open({ bedDetails: this.bedDetails })
        .then((success) => {
          if (success) this.reload()
        })
    },
    showBalance(value) {
      this.showAmountDue = value
    },
    paidItemRow(isExpanded) {
      if (isExpanded) return 'row-item-expanded'
      else return
    },
    expandedItemRow(index, items) {
      // if(index === 0) return 'expand-item'
      if (index >= items.length - 1) return 'expand-item bottom-border'
      return 'expand-item'
    },
    cancelPaidPayment(item) {
      this.$refs.cancelPaidPayment.open(item).then(() => {
        this.reload()
      })
    },
    voidPaidPayment(item) {
      this.$refs.voidPaidPayment.open(item).then(() => {
        this.reload()
      })
    },
    paymentDetailItemAmountPaid(payment, paidPaymentId) {
      const items = payment.paidItems || []
      return (
        items
          .filter((item) => item.paidPaymentId === paidPaymentId)
          .reduce((a, b) => a + b.amount, 0) ||
        payment.amountPaid ||
        0
      )
    },
    expandAll() {
      this.expandedPayments = this.payments
      this.allExpanded = true
    },
    collapseAll() {
      this.expandedPayments = []
      this.allExpanded = false
    },
    togglePaymentMobile(payment) {
      if (this.expandedPayments.length > 0) {
        this.expandedPayments = []
        this.togglePaymentMobileIcon = 'mdi-chevron-down'
      } else {
        this.expandedPayments = [payment]
        this.togglePaymentMobileIcon = 'mdi-chevron-up'
      }
    },
    generateId() {
      return nanoid(5)
    },
    hasPartialPayments(item) {
      return item.payment_details.some((p) => p.status === 'Partial Payment')
    },
    async setSendNotification() {
      let confirm = false
      if (this.sendNotification) {
        confirm = await this.$root.$confirm({
          title: 'Disable Notifications',
          message: `Are you sure you would like to disable notifications? All emails and SMS messages will not be sent to the tenant.`,
          confirmText: 'OK'
        })
      } else {
        confirm = await this.$root.$confirm({
          title: 'Enable Notifications',
          message: `Are you sure you would like to enable notifications? All emails and SMS messages will be sent to the tenant.`,
          confirmText: 'OK'
        })
      }
      if (confirm) {
        this.sendNotification = !this.sendNotification
        this.$store.dispatch('units/updateSendNotificationAction', {
          leaseId: this.bedDetails.leaseId,
          sendNotification: this.sendNotification
        })
      }
    },
    setShowUpdateRentalPeriod() {
      this.showUpdateRentalPeriod = true
      this.updateNextRentalStartDate = dayjs(this.nextRentalStartDate).format(
        'YYYY-MM-DD'
      )
    },
    setHideUpdateRentalPeriod() {
      this.showUpdateRentalPeriod = false
    },
    async saveRentalPeriod() {
      await this.$store.dispatch('units/saveRentalPeriodAction', {
        leaseId: this.bedDetails.leaseId,
        startDate: dayjs(this.updateNextRentalStartDate).format(),
        endDate: dayjs(this.updateNextRentalEndDate).format()
      })
      this.showUpdateRentalPeriod = false
      this.reload()
    },
    formatDateMobile(date) {
      return dayjs(date).format('YYYY/MM/DD')
    },
    editUnitTags() {
      this.$refs.editUnitTags.open({
        bedId: this.bedDetails.bedId,
        bedName: this.bedDetails.bedName
      })
    },
    onAddTag(tag) {
      if (this.bedDetails.tags) {
        this.bedDetails.tags.push(tag)
      } else {
        this.bedDetails.tags = [tag]
      }
    },
    approvePaymentRequest(payment) {
      this.$refs.approvePaymentRequest.open(payment).then(() => {
        this.reload()
      })
    },
    rejectPaymentRequest(paymentId) {
      this.$root
        .$confirm({
          title: 'Reject payment request',
          message: 'Are you sure you want to reject the payment request?'
        })
        .then(async () => {
          if (confirm) {
            await this.$store.dispatch('payments/rejectPaymentRequestAction', {
              paymentId
            })
            await this.reload()
          }
        })
    },
    approvePaidPayment(paidPayment) {
      this.$refs.approvePaidPayment.open(paidPayment).then(() => {
        this.reload()
      })
    },
    rejectPaidPayment(paidPaymentId) {
      this.$root
        .$confirm({
          title: 'Reject payment',
          message: 'Are you sure you want to reject the payment?'
        })
        .then(async (confirm) => {
          if (confirm) {
            await this.$store.dispatch('payments/rejectPaidPaymentAction', {
              paidPaymentId
            })
            await this.reload()
          }
        })
    },
    generateMonthlyStatement() {
      this.$refs.generateMonthToDateStatement.open(this.bedDetails)
    },
    createSecurityDeposit() {
      this.$refs.createSecurityDeposit.open(hashids.decode(this.bedId)[0])
    },
    showSnackbar(message) {
      this.snackbar = true
      this.snackbarText = message
    },
    formatFullDate(date) {
      return dayjs(date).format(FULLDATE)
    },
    async fetchUnpaidPreviousRentalPaymentRequests() {
      const response = await this.$store.dispatch(
        'units/fetchLeaseRentalPaymentRequests',
        {
          leaseId: this.bedDetails.leaseId
        }
      )

      const unpaidPreviousRentalPaymentRequests = response.filter(
        (payment, index) =>
          payment.status === PaymentStatus.PENDING && index !== 0
      )

      return unpaidPreviousRentalPaymentRequests
    }
  }
}
</script>

<style scoped>
.v-card.main-card {
  min-height: 80vh;
}
.v-speed-dial {
  bottom: 3vw;
  right: 3vw;
}
.v-card.card-container {
  border-radius: 12px !important;
}
.v-input {
  border-radius: 10px;
}
table tbody tr td {
  /*border: none !important;
    border-bottom: none !important;
    border-right: 1px !important;*/
  border-color: #eeeeee !important;
}
p {
  margin-bottom: 0;
}
#chart-card {
  /*background-color: #566fbc;*/
}
.v-data-table,
th {
  background-color: transparent !important;
  background: transparent !important;
}
.text-overflow {
  max-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-item-expanded {
  /*background-color: #e9ecf0;*/
}
.row-item-expanded td p {
  font-weight: bold;
}
.row-item-expanded td {
  border: none !important;
}
.expand-item {
  /*background-color: #FAFAFA;*/
}
.expand-item td p {
  font-weight: 300;
  font-size: 11px !important;
}
.expand-item td {
  border: none !important;
}
tr.top-border td {
  border-top: thin solid #ccc !important;
}

tr.bottom-border td {
  /*border-bottom: thin solid #CCC !important;*/
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

tr.x-border td:first-child {
  border-left: thin solid #ccc !important;
}

tr.x-border td:last-child {
  border-right: thin solid #ccc !important;
}
.table-footer-prepend {
  margin-top: -54px;
  height: 48px;
}
.test {
  border: 2px solid yellow;
}
</style>
